// import { ICustomer } from '@models/Customer';
// import { IOrderManager, statusDetail } from '@models/OrderManager';
// import { COMPANY_NAMES, Cancel, ConfirmWait, InHold, InProcess, Pause, Success } from 'global/Global';
// import Helpers from 'helpers/Helpers';
// import { IDetailsItem } from 'models/CreateOrder';
// import { IProductCategory } from 'models/StockManage/CateProductManage';
// import moment from 'moment';

// import React, { useState } from 'react';

// export const convertTime = {
//   days7: `${moment().subtract(6, 'd').format('YYYY-MM-DD')}T00:00:00.000Z`,
//   begin: `${moment().year()}-${
//     moment().month() + 1 < 10 ? `0${moment().month() + 1}` : `${moment().month() + 1}`
//   }-${moment().date()}T00:00:00.000Z`,
//   end: `${moment().year()}-${
//     moment().month() + 1 < 10 ? `0${moment().month() + 1}` : `${moment().month() + 1}`
//   }-${moment().date()}T23:59:59.000Z`
// };

// export const defaultMoney = {
//   totalMoney: 0,
//   totalMoneySum: 0,
//   payedMoney: 0,
//   payedMoneySum: 0,
//   vatAmount: 0,
//   vatAmountSum: 0
// };
// // interface IUtilOrder
// export interface IUtilOrder {
//   /**
//    * Tăng SL sản phẩm
//    */
//   upQuantity: (itemUQ: IProductCategory, data: Array<IProductCategory>) => Array<IProductCategory>;

//   /**
//    * Giảm  SL sản phẩm
//    * @param
//    * @returns
//    */
//   downQuantity: (itemDQ: IProductCategory, data: Array<IProductCategory>) => Array<IProductCategory>;

//   /**
//    * Thay đổi giá sản phẩm
//    * @param
//    * @param
//    * @returns
//    */
//   changePrice: (
//     value: React.ChangeEvent<HTMLInputElement>,
//     itemP: IProductCategory,
//     data: Array<IProductCategory>
//   ) => Array<IProductCategory>;

//   /**
//    * Thay đổi item chi tiết
//    * @param
//    * @param
//    * @returns
//    */
//   addDetailToItem: (
//     serial: string,
//     Bs: string,
//     vehicleType: string,
//     data: IProductCategory,
//     dataList: Array<IProductCategory>,
//     isUpdate?: boolean
//   ) => Array<IProductCategory>;

//   /**
//    * Xoá Item in detail Item list
//    * @param
//    * @param
//    * @returns
//    */
//   deleteDetailItem: (
//     itemD: IDetailsItem,
//     data: IProductCategory,
//     dataList: Array<IProductCategory>
//   ) => Array<IProductCategory>;

//   /**
//    * Thay đổi item chi tiết số lượng lớn
//    * @param
//    * @param
//    * @returns
//    */
//   addQuickDetailToItem: (
//     startSerial: string,
//     data: IProductCategory,
//     dataList: Array<IProductCategory>,
//     amount: number
//   ) => Array<IProductCategory>;

//   /**
//    * Thay đổi số lượng sản phẩm
//    * @param
//    * @param
//    * @returns
//    */
//   changeQuantity: (
//     value: React.ChangeEvent<HTMLInputElement>,
//     itemQ: IProductCategory,
//     data: Array<IProductCategory>
//   ) => Array<IProductCategory>;

//   /**
//    * Thay đổi số lượng sản phẩm
//    * @param
//    * @param
//    * @returns
//    */
//   sumPriceFormat: (price: number, quantity: number) => string;

//   /**
//    * Chuyển trạng thái đơn dạng string text từ server sang dạng string number và kèm màu sắc để dùng dưới client
//    * có kièm theo language
//    * @return {
//    * text: language,
//    * value: string dạng số 1,2...
//    * color: string
//    * }
//    */
//   convertStatusTextToStatusClient: (currentStatus: string, operatorSeen?: boolean) => any;

//   convertOrderType: (type: any) => any;
//   /**
//    * Hàm phân loại đơn có phải thuộc tab quản lý hay không
//    * @param valueStatus giá trị hiện tại cần phân loại ra
//    * @returns trả về string là dạng loại đơn
//    */
//   classificationOrder: (valueStatus?: string) => any;
//   // Hàm lấy trạng thái của đơn
//   listCurrentStatus: (arrayCurrentStatus?: any) => any;
//   /**
//    * Chuyển về format tiền + sản phẩm đơn hàng để hiển thị trong table ql đơn
//    */
//   moneyTotalOrderFormat: (items: any) => string;

//   formatVarOrder: (orders: IOrderManager) => IOrderManager;
//   formatVarCustomer: (customers: ICustomer) => ICustomer;

//   /**
//    * Chuyển dữ liệu đơn sau khi nhận từ server về đúng dạng cần thiết
//    * đếm số lượng đơn theo trạng thái rồi trả về tại hàm này luôn !!!
//    */
//   formatDataOrders: (orders: any[]) => any;
//   formatDataCustomers: (customers: any[]) => any;

//   /**
//    * Đếm số lượng đơn theo trạng thái rồi trả về các tổng trạng thái tương ứng !!!
//    */
//   countOrders: (orders: IOrderManager[]) => any;
//   /**
//    * Truyền key lấy dữ liệu giới hạn tiền  !!!
//    */
//   getDataOMConfig: (datas, key) => any;

//   /**
//    * Chuyển dữ liệu của 1 đơn hàng từ dạng đơn cơ bản sang dạng đơn chi tiết nhất (dữ liệu đầy đủ nhất)
//    *
//    */
//   formatOneDataOrder: (order: any, isReport?: boolean) => any;

//   formatCacLoaiDon: (don: any) => any;

//   /**
//    * Hàm chuyển id đơn hàng sang mẫu text để gọi api
//    * @param oderTypeId number id loại đơn hàng
//    * @returns
//    */
//   convertIdTypeOrderToNameAPI: (oderTypeId: number) => any;

//   /**
//    * Hàm tạo list detail sản phẩm
//    * @param valueQuick list thêm bộ rã ra sản phẩm bên trong
//    * @param maSanPham mã sp gốc đã chọn
//    * @param amount sl tb cần add vào
//    * @returns arr sản phẩm
//    */
//   makeDetailBase: (valueQuick: any, maSanPham: any, amount: any) => any;

//   /**
//    * Hàm tạo summary từ detail đã thêm tay vào, hiện đang dùng cho đơn ĐL lắp giùm
//    * @param data list detail các sản phẩm của đơn từng xe
//    * @param preDevice danh sách thiết bị hiện tại có giá => lấy giá để dùng lại
//    * @returns 1 obj arr devices, quantities, price dùng để tạo lại dữ liệu cho store devices
//    */
//   handleCalSumByDetail: (data: any, preDevice: any) => any;
// }

// const UtilOrder: IUtilOrder = {
//   upQuantity: (itemUQ: IProductCategory, data: Array<IProductCategory>) => {
//     return data.map((item: IProductCategory) => {
//       if (item.name === itemUQ.name) return { ...item, Quantity: item.Quantity! + 1 };
//       return { ...item };
//     });
//   },

//   downQuantity: (itemDQ: IProductCategory, data: Array<IProductCategory>) => {
//     return data.map((item: IProductCategory) => {
//       if (item.name === itemDQ.name && itemDQ.Quantity! > 1) return { ...item, Quantity: item.Quantity! - 1 };
//       return { ...item };
//     });
//   },

//   changePrice: (value: React.ChangeEvent<HTMLInputElement>, itemP: IProductCategory, data: Array<IProductCategory>) => {
//     const tempValueCovert = value.target.value.toString().replaceAll(',', '');
//     // console.log(
//     //   'changePrice',
//     //   itemP,
//     //   tempValueCovert,
//     //   data,
//     //   Helpers.isNumeric(tempValueCovert) && Number(tempValueCovert) >= 0
//     // );
//     const valueSet = Helpers.isNumeric(tempValueCovert) && Number(tempValueCovert) > 0 ? Number(tempValueCovert) : 0;

//     return data.map((item: IProductCategory) => {
//       // console.log('map', item.name, itemP.name, Number(tempValueCovert));
//       if (item.name === itemP.name) return { ...item, priceMuch: valueSet, giaBanSi: valueSet };
//       return { ...item };
//     });
//   },

//   changeQuantity: (
//     value: React.ChangeEvent<HTMLInputElement>,
//     itemQ: IProductCategory,
//     data: Array<IProductCategory>
//   ) => {
//     if (Helpers.isNumeric(value.target.value) && Number(value.target.value) > 0) {
//       return data.map((item: IProductCategory) => {
//         if (item.name === itemQ.name) return { ...item, Quantity: Number(value.target.value) };
//         return { ...item };
//       });
//     }
//     return data;
//   },

//   deleteDetailItem: (itemD: IDetailsItem, data: IProductCategory, dataList: Array<IProductCategory>) => {
//     return dataList.map(item => {
//       if (item.name === data.name) {
//         const newDetails = item.details?.filter(itemF => itemF.maSanPham !== itemD.maSanPham);

//         return { ...item, details: newDetails };
//       }
//       return { ...item };
//     });
//   },
//   addDetailToItem: (
//     serial: string,
//     Bs: string,
//     vehicleType: string,
//     data: IProductCategory,
//     dataList: Array<IProductCategory>,
//     isUpdate?: boolean
//   ) => {
//     let isStop = false;

//     const arrProcess = dataList.map((item: IProductCategory) => {
//       if (item.name === data.name && item.requireDetail) {
//         if (isUpdate === true) {
//           let newArrOC;
//           item.details?.map(itemA => {
//             if (itemA.maSanPham === serial) {
//               // đã tồn tại serial => thay itemA bằng tempO
//               newArrOC = item.details?.map(object => {
//                 if (object.maSanPham === serial) {
//                   return { ...object, vehicleType: vehicleType, registrationPlate: Bs };
//                 }
//                 return object;
//               });
//             }
//           });

//           return { ...item, details: newArrOC };
//         }
//         item.details?.map(itemA => {
//           if (itemA.maSanPham === serial) {
//             // đã tồn tại serial => từ chối thao tác
//             isStop = true;
//           }
//         });

//         const tempO = { maSanPham: serial, vehicleType: vehicleType, registrationPlate: Bs };
//         // thêm mới
//         const addArrOA = item.details && [...item.details, tempO];

//         return {
//           ...item,
//           details: addArrOA
//         };
//       }
//       return { ...item };
//     });

//     if (isStop) return [];
//     return arrProcess;
//   },

//   addQuickDetailToItem: (
//     startSerial: string,
//     data: IProductCategory,
//     dataList: Array<IProductCategory>,
//     amount: number
//   ) => {
//     let isStop = false;
//     const arrProcess = dataList.map((item: IProductCategory) => {
//       if (item.name === data.name && item.requireDetail) {
//         let startSerialNext = Number(startSerial);
//         let i = 0;
//         const arraySerial: string[] = [];
//         while (i < amount) {
//           item.details?.map(itemA => {
//             if (Number(itemA.maSanPham) === startSerialNext) {
//               // đã tồn tại serial => từ chối thao tác
//               isStop = true;
//             }
//           });
//           arraySerial.push(Number(startSerialNext).toString());
//           startSerialNext += 1;
//           i += 1;
//         }
//         const tempO = arraySerial.map(item => ({
//           maSanPham: item
//         }));
//         const addArrOA = item.details && [...item.details, ...tempO];
//         return {
//           ...item,
//           details: addArrOA
//         };
//       }
//       return { ...item };
//     });

//     if (isStop) return [];
//     return arrProcess;
//   },

//   sumPriceFormat: (price: number, quantity: number) => {
//     const sumPrice = price * quantity;
//     return Helpers.FormatMoney(sumPrice);
//   },

//   moneyTotalOrderFormat: (item: any) => {
//     const quantity = item.items?.length > 0 ? `${item.items?.length} loại thiết bị - ` : '';
//     return quantity + Helpers.FormatMoney(Number(item.tienThanhToan));
//   },

//   convertOrderType(type: number) {
//     switch (type) {
//       case 1:
//         return 'Hàng gửi';
//       case 2:
//         return 'Lắp mới';
//       case 3:
//         return 'Thu phí';
//       case 4:
//         return 'Sửa chữa';
//       case 5:
//         return 'Bảo hành';
//       case 6:
//         return 'Thu đổi';
//       case 7:
//         return 'Nâng cấp';
//       case 8:
//         return 'Tháo - Lắp lại';
//       case 9:
//         return 'ĐL lắp giùm';
//       case 10:
//         return 'Lắp giùm ĐL';
//       case 11:
//         return 'Thu nợ';
//       case 12:
//         return 'Trả hàng';
//       case 13:
//         return 'Chênh lệch';
//       case 14:
//         return 'Hoàn tiền';

//       default:
//         break;
//     }
//     // 'Hàng gửi',
//     //       'Lắp mới',
//     //       'Thu phí',
//     //       'Sửa chữa',
//     //       'Bảo hành',
//     //       'Thu đổi',
//     //       'Nâng cấp',
//     //       'Tháo - Lắp lại',
//     //       'ĐL lắp giùm',
//     //       'Lắp giùm ĐL'
//   },

//   convertStatusTextToStatusClient: (currentStatus: string, operatorSeen?: boolean) => {
//     switch (currentStatus) {
//       case '0':
//         return {
//           text: '',
//           statusValue: '',
//           color: '#fff', // trắng màu nền..
//           vnText: ''
//         };
//       case 'Pause': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.Pause',
//           statusValue: '111',
//           color: '#faad14', // vàng màu nền..
//           vnText: 'Tạm dừng'
//         };
//       case 'accountantTrue': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
//         return {
//           text: 'Report.FeeTracking.AccountantTrue',
//           statusValue: '111',
//           color: '#008000', // vàng màu nền..
//           vnText: 'Đã thu tiền'
//         };
//       case 'accountantFalse': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
//         return {
//           text: 'Report.FeeTracking.AccountantFalse',
//           statusValue: '112',
//           color: '#db856c', // vàng màu nền..
//           vnText: 'Chưa thu tiền'
//         };
//       case 'operateTrue': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
//         return {
//           text: 'Report.FeeTracking.OperateTrue',
//           statusValue: '113',
//           color: '#008000', // vàng màu nền..
//           vnText: 'Đã thu tiền'
//         };
//       case 'operateFalse': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
//         return {
//           text: 'Report.FeeTracking.OperateFalse',
//           statusValue: '114',
//           color: '#db856c', // vàng màu nền..
//           vnText: 'Chưa thu tiền'
//         };
//       case 'New': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.WaitApproveOrder',
//           statusValue: '1',
//           color: '#F39C12', // vàng màu nền..
//           vnText: 'Chờ duyệt'
//         };
//       case 'Processing': // đang thực hiện đơn (kthuat nhấn bắt đầu)
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.InProcessOrder',
//           statusValue: '2',
//           color: '#006c87', //  xanh biển 0,
//           vnText: 'Đang thực hiện'
//         };
//       case 'Pending': // đơn bị hoẵn lại do các lý do nào đó..
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.HoldOnOrder',
//           statusValue: '3',
//           color: '#979797', // xám
//           vnText: 'Đơn hẹn lại'
//         };
//       case 'Complete': // đơn thành công
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.CompleteOrder',
//           statusValue: '4',
//           color: '#008000', //  xanh lá
//           vnText: 'Hoàn tất'
//         };
//       case 'Cancel': // đơn đã huỷ
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.CancelOrder',
//           statusValue: '5',
//           color: '#f50815', // đỏ đô đậm
//           vnText: 'Đã huỷ'
//         };
//       case 'NotApproved': // đơn đã từ chối có thể là kto từ chối công nợ
//         // từ chối xong là đơn này kết thúc k còn thao tác gì nữa
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.DeclineOrder',
//           statusValue: '6',
//           color: '#b06f09', // vàng đậm,
//           vnText: 'Từ chối'
//         };

//       case 'Assigned': // Đã được phân công từ điều hành xuống Kthuat
//         // bắt đầu từ đây thì đơn cứ ở đã điều phối | chờ thực hiện, khi nào có kth bắt đầu thì chuyển qua
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.Assigned',
//           statusValue: '7',
//           color: '#00BFFF', // xanh biển 1
//           vnText: 'Chờ thực hiện'
//         };

//       // chưa dùng
//       case '8': // đợi nhập liệu
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.WaitEnter',
//           statusValue: '8',
//           color: '#0069cb' // xanh biển 2
//         };

//       case '9': // đợi sữa chữa
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.WaitRepair',
//           statusValue: '9',
//           color: '#0069cb' // xanh biển 2
//         };

//       case '10': // Chờ nhận gửi
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.ComfirmShip',
//           statusValue: '10',
//           color: '#db856c' // đỏ nhạt
//         };

//       case '11': // đơn đợi đang gửi
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.WaitShip',
//           statusValue: '11',
//           color: '#6974a0' // tím nhạt
//         };
//       // chưa dùng
//       // lưu ý khi cskh tạo đơn thì đơn này nhảy qua tới đơn hợp lệ luôn k cần qua bước ktoan
//       case 'Approved': // đơn hợp lệ kto đã chấp thuận
//         // bên trong này sẽ có thêm 1 trạng thái nhỏ nữa là dùng operatorSeen
//         // để chuyển trạng thái Chờ điều phối thành Chờ tiếp nhận nếu  operatorSeen = false;
//         // nếu operatorSeen = true thì mới đúng là chờ điều phối. về chức năng thì là như nhau
//         return {
//           text: 'OrganizedSales.OrderManager.TabName.Approved',
//           seen: operatorSeen != undefined ? operatorSeen : true,
//           statusValue: '12',
//           color: '#6c0082', // chàm nhạt
//           vnText: 'Chờ điều phối'
//         };

//       default:
//         return {
//           text: 'Không rõ',
//           statusValue: '0',
//           color: '#fff' // trắng
//         };
//     }
//   },

//   listCurrentStatus(arrayCurrentStatus?: any) {
//     let arrayCurrent = '';
//     for (let i = 0; i < arrayCurrentStatus.length; i++) {
//       if (arrayCurrentStatus.length > 1) {
//         if (arrayCurrentStatus[i].currentStatus == 'Complete' || arrayCurrentStatus[i].currentStatus == 'Cancel') {
//           arrayCurrent = 'Complete';
//         } else {
//           return (arrayCurrent = 'Approved');
//         }
//       } else {
//         if (arrayCurrentStatus[i].currentStatus == 'Complete' || arrayCurrentStatus[i].currentStatus == 'Cancel') {
//           return (arrayCurrent = 'Complete');
//         } else {
//           return (arrayCurrent = 'Approved');
//         }
//       }
//     }
//     return arrayCurrent;
//   },

//   classificationOrder: (valueStatus?: string) => {
//     if (ConfirmWait.includes(valueStatus)) {
//       return 'ConfirmWait';
//     }
//     if (InProcess.includes(valueStatus)) {
//       return 'InProcess';
//     }
//     if (Pause.includes(valueStatus)) {
//       return 'Pause';
//     }
//     if (InHold.includes(valueStatus)) {
//       return 'InHold';
//     }
//     if (Success.includes(valueStatus)) {
//       return 'Success';
//     }
//     if (Cancel.includes(valueStatus)) {
//       return 'Success';
//     }
//     return '';
//   },

//   formatVarOrder: (order: IOrderManager) => {
//     const statusFormat = UtilOrder.convertStatusTextToStatusClient(order.currentStatus, order.operatorSeen);
//     return {
//       ...order,
//       branchName: order.branchInfo.name,
//       status: statusFormat,
//       statusVNText: statusFormat.vnText,
//       uuTien: order.isPrioritized ? 'Ưu tiên' : '–',
//       loaiDonHang: order.orderType.name,
//       DeliverTime: new Date(order.times.thoiGianHenLap),
//       CreateTime: new Date(order.times.thoiGianTao),
//       CompleteTime: new Date(order.times.thoiGianHoanThanh),
//       CustomerName: order.customerInfo.customerName || '–',
//       tenCongTy: order.companyName === 'AnhDuong' ? 'Ánh Dương' : order.companyName === 'BinhMinh' ? 'Bình Minh' : '',
//       AddressShip: order.customerInfo?.orderAddress?.address || '–',
//       StaffCreate: order.staffCreate || '–',
//       StaffOperate: order.staffOperate || '–',
//       StaffProcesser: order.executeInfo?.map(staff => staff.staffExecute)?.join('; ') || '–',
//       StaffApprove: order.staffApprove || '–',
//       vatValue: order.orderVat?.vatValue || 0,
//       useVAT: order.orderVat?.vatValue !== '' ? 'Có' : '–',
//       totalMoney: Helpers.FormatMoney(
//         order.payment.tienThanhToan ||
//           ((order.orderType?.id === 4 || order.orderType?.id === 5) &&
//             order.payment.tienDuKien + order.payment.chiPhiPhatSinh) ||
//           0,
//         true
//       ), // đơn sc bh thì dùng tiền dự kiến trên server trả về khi tạo đó
//       totalMoneySum:
//         order.payment.tienThanhToan + order.payment.chiPhiPhatSinh ||
//         ((order.orderType?.id === 4 || order.orderType?.id === 5) &&
//           order.payment.tienDuKien + order.payment.chiPhiPhatSinh) ||
//         0,
//       payedMoney: Helpers.FormatMoney(order.payment.tienThucThu, true),
//       payedMoneySum: order.payment.tienThucThu,
//       vatAmount: Helpers.FormatMoney(order.payment.vatAmount, true),
//       vatAmountSum: order.payment.vatAmount,
//       DeviceList: null,
//       DetailOrder: null,
//       CSCalled: order.customerServiceCall.isCalled ? 'Đã gọi KH' : '–',
//       yeuCauChinhSuaText:
//         order.yeuCauChinhSua === 2 ? 'Đã cập nhật' : order.yeuCauChinhSua === 1 ? 'Chưa cập nhật' : '–',
//       CusNumberPhone: order.customerInfo.customerPhone || '',
//       ContactNumberPhone: order.customerInfo.sdtLienHe || '',
//       DeviceListTag: 'OrganizedSales.OrderManager.AllOrder.ClickToView'
//     };
//   },
//   formatVarCustomer: (customer: ICustomer) => {
//     return {
//       ...customer,
//       Address: customer.address,
//       PhoneList: customer.phoneList.map(phone => phone.phone).join(' ') + ' ',
//       StaffSale: customer.listKinhDoanh.map(sale => sale.saleAccount).join(' ') + ' ',
//       VATExport: (customer.customerVat?.vatValue || 0) + '%'
//     };
//   },

//   formatDataOrders: (orders: IOrderManager[]) => {
//     const tempArray: any[] = new Array(orders?.length);

//     for (let i = 0; i < orders?.length; i++) {
//       const order = orders[i];
//       tempArray[i] = UtilOrder.formatVarOrder(order);
//     }

//     return {
//       data: tempArray
//     };
//   },

//   formatDataCustomers: (customers: ICustomer[]) => {
//     const tempArray: any[] = new Array(customers?.length);

//     for (let i = 0; i < customers?.length; i++) {
//       const customer = customers[i];
//       tempArray[i] = UtilOrder.formatVarCustomer(customer);
//     }

//     return {
//       data: tempArray
//     };
//   },

//   getDataOMConfig(datas, key) {
//     for (let i = 0; i < datas?.data?.length; i++) {
//       if (datas?.data[i].key === key) {
//         return Number(datas?.data[i].data);
//       }
//     }
//     return 0;
//   },

//   countOrders: (orders: IOrderManager[]) => {
//     let ConfirmWaitCount = 0;
//     let InProcessCount = 0;
//     let InHoldCount = 0;
//     let SuccessCount = 0;
//     let UnSuccesCount = 0;
//     let PauseCount = 0;
//     // let CancelCount = 0;
//     for (let i = 0; i < orders?.length; i++) {
//       const order = orders[i];
//       const statusTag = UtilOrder.classificationOrder(order?.currentStatus);
//       switch (statusTag) {
//         case 'ConfirmWait':
//           ConfirmWaitCount += 1;
//           UnSuccesCount += 1;
//           break;
//         case 'InProcess':
//           InProcessCount += 1;
//           UnSuccesCount += 1;
//           break;
//         case 'InHold':
//           InHoldCount += 1;
//           UnSuccesCount += 1;
//           break;
//         case 'Success':
//           SuccessCount += 1;
//           break;
//         case 'Pause':
//           PauseCount += 1;
//           break;
//         case 'Cancel':
//           SuccessCount += 1;
//           break;
//         default:
//           break;
//       }
//       // phần xử lí đếm lượng đơn phân loại
//     }

//     return {
//       ConfirmWaitCount: ConfirmWaitCount,
//       InProcessCount: InProcessCount,
//       InHoldCount: InHoldCount,
//       SuccessCount: SuccessCount,
//       PauseCount: PauseCount,
//       // CancelCount: CancelCount,
//       AllCount: orders.length,
//       UnSuccesCount: UnSuccesCount
//     };
//   },

//   formatCacLoaiDon(don: any) {
//     if (
//       don.type === 'Lắp mới' ||
//       don.type === 'Hàng gửi' ||
//       don.type === 'Thu đổi' ||
//       don.type === 'ĐL lắp giùm' ||
//       don.type === 'Lắp giùm ĐL'
//     ) {
//       if (don.item.details?.length > 0) {
//         // lọc bên trong chi tiết của từng sản phẩm tương ứng
//         // console.log('eeyy 2', detailsFlr);
//         const detailsFlr = don.item.details.filter(
//           detail =>
//             (detail.maSanPham == don.item.maSanPham && detail.maBo == '') || // sản phẩm lẻ
//             detail.maBo == don.item.maSanPham // thuộc bộ
//         );
//         if (detailsFlr.length != 0) {
//           detailsFlr.forEach((itemDetail, num) => {
//             if (don.num0 === 0 && num === 0) {
//               const detailOrder = {
//                 ...don.tempData,
//                 ...itemDetail,
//                 phiGiaHan: 0,
//                 phiGiaHanSum: 0,
//                 noteDetails: itemDetail['note'],
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 tienDuKien: don.tempData.payment.tienDuKien,
//                 // maSanPham:
//                 //   itemDetail.maSanPham +
//                 //   ' ' +
//                 //   (itemDetail.tenBo?.length != 0 ? '(' + itemDetail?.tenBo + ')' : '(' + itemDetail?.tenSanPham + ')'),

//                 // Sửa lại hiển thị theo tên sản phẩm
//                 maSanPham:
//                   itemDetail.tenSanPham +
//                   ' ' +
//                   (itemDetail.tenBo?.length != 0 ? '(' + itemDetail?.tenBo + ')' : '(' + itemDetail?.tenSanPham + ')'),
//                 //
//                 costSum: itemDetail.maBo == '' ? don.item.cost : itemDetail.serial != '' ? don.item.cost : 0,
//                 cost: Helpers.FormatMoney(
//                   itemDetail.maBo == '' ? don.item.cost : itemDetail.serial != '' ? don.item.cost : 0,
//                   true
//                 ),
//                 countOrder: 1
//               };
//               don.arrOrder.push(detailOrder);
//             } else {
//               const detailOrder = {
//                 ...don.tempData,
//                 ...itemDetail,
//                 phiGiaHan: 0,
//                 phiGiaHanSum: 0,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 tienDuKien: 0,
//                 noteDetails: itemDetail['note'],
//                 // Sửa lại hiển thị theo tên sản phẩm
//                 maSanPham:
//                   itemDetail.tenSanPham +
//                   ' ' +
//                   (itemDetail.tenBo?.length != 0 ? '(' + itemDetail?.tenBo + ')' : '(' + itemDetail?.tenSanPham + ')'),
//                 //
//                 costSum: itemDetail.maBo == '' ? don.item.cost : itemDetail.serial != '' ? don.item.cost : 0,
//                 cost: Helpers.FormatMoney(
//                   itemDetail.maBo == '' ? don.item.cost : itemDetail.serial != '' ? don.item.cost : 0,
//                   true
//                 ),
//                 tienCong: 0,
//                 tienCongSum: 0,
//                 totalMoney: 0,
//                 totalMoneySum: 0,
//                 payedMoney: 0,
//                 payedMoneySum: 0,
//                 vatAmount: 0,
//                 vatAmountSum: 0,
//                 countOrder: 0
//               };
//               don.arrOrder.push(detailOrder);
//             }
//           });
//         } else {
//           don.arrOrder.push(
//             don.num0 === 0
//               ? { ...don.tempData, hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan, countOrder: 1 }
//               : {
//                   ...don.tempData,
//                   phiGiaHan: 0,
//                   phiGiahanSum: 0,
//                   hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                   totalMoney: 0,
//                   totalMoneySum: 0,
//                   payedMoney: 0,
//                   payedMoneySum: 0,
//                   vatAmount: 0,
//                   vatAmountSum: 0,
//                   tienCong: 0,
//                   tienCongSum: 0,
//                   countOrder: 0
//                 }
//           ); // chưa có chi tiết nào cho loại sp này thì add sp vô thôi
//         }
//       } else {
//         // nếu chi tiết chưa có thì lấy cái cơ bản
//         don.arrOrder.push(
//           don.num0 === 0
//             ? { ...don.tempData, hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan, countOrder: 1 }
//             : {
//                 ...don.tempData,
//                 phiGiaHan: 0,
//                 phiGiahanSum: 0,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 totalMoney: 0,
//                 totalMoneySum: 0,
//                 payedMoney: 0,
//                 payedMoneySum: 0,
//                 vatAmount: 0,
//                 vatAmountSum: 0,
//                 tienCong: 0,
//                 tienCongSum: 0,
//                 countOrder: 0
//               }
//         );
//       }
//     } else if (don.type === 'Thu phí') {
//       if (don.item.details.length > 0) {
//         don.item.details.forEach((itemDetail, index) => {
//           if (index === 0) {
//             const detailOrder = {
//               ...don.tempData,
//               ...itemDetail,
//               hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//               tienDuKien: don.tempData.payment.tienDuKien,
//               noteDetails: itemDetail['note'],
//               // costSum: itemDetail['cost'],
//               // cost: Helpers.FormatMoney(itemDetail['cost'], true),
//               cost: 0,
//               costSum: 0,
//               phiGiaHanSum: itemDetail['cost'],
//               phiGiaHan: Helpers.FormatMoney(itemDetail['cost'], true),
//               registrationPlate: itemDetail['bs'],
//               countOrder: 1
//             };
//             don.arrOrder.push(detailOrder);
//           } else {
//             const detailOrder = {
//               ...don.tempData,
//               ...itemDetail,
//               hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//               tienDuKien: 0,
//               noteDetails: itemDetail['note'],
//               // costSum: itemDetail['cost'],
//               // cost: Helpers.FormatMoney(itemDetail['cost'], true),
//               cost: 0,
//               costSum: 0,
//               phiGiaHanSum: itemDetail['cost'],
//               phiGiaHan: Helpers.FormatMoney(itemDetail['cost'], true),
//               registrationPlate: itemDetail['bs'],
//               totalMoney: 0,
//               totalMoneySum: 0,
//               payedMoney: 0,
//               payedMoneySum: 0,
//               vatAmount: 0,
//               vatAmountSum: 0,
//               tienCong: 0,
//               tienCongSum: 0,
//               countOrder: 0
//             };
//             don.arrOrder.push(detailOrder);
//           }
//         });
//       } else {
//         // nếu chi tiết chưa có thì lấy cái cơ bản
//         don.arrOrder.push(
//           don.num0 === 0
//             ? {
//                 ...don.tempData,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 countOrder: 1
//               }
//             : {
//                 ...don.tempData,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 totalMoney: 0,
//                 totalMoneySum: 0,
//                 payedMoney: 0,
//                 payedMoneySum: 0,
//                 vatAmount: 0,
//                 vatAmountSum: 0,
//                 tienCong: 0,
//                 tienCongSum: 0,
//                 countOrder: 0
//               }
//         );
//       }
//     } else if (don.type === 'Sửa chữa' || don.type === 'Bảo hành') {
//       if (don.item.details.length > 0) {
//         don.item.details.forEach((itemDetail, index) => {
//           // console.log('itemDetail',  don.tempData);
//           if (index === 0) {
//             const detailOrder = {
//               ...don.tempData,
//               ...itemDetail,
//               hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//               tienDuKien: don.tempData.payment.tienDuKien,
//               noteDetails: itemDetail['note'],
//               note: don.tempData.note,
//               costSum: itemDetail['cost'],
//               cost: Helpers.FormatMoney(itemDetail['cost'], true),
//               phiGiaHan: 0,
//               phiGiaHanSum: 0,
//               maSanPham: itemDetail['newMaSanPham'],
//               serial: itemDetail['newSerial'],
//               countOrder: 1
//             };
//             don.arrOrder.push(detailOrder);
//           } else {
//             const detailOrder = {
//               ...don.tempData,
//               ...itemDetail,
//               hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//               tienDuKien: 0,
//               phiGiaHan: 0,
//               phiGiaHanSum: 0,
//               noteDetails: itemDetail['note'],
//               costSum: itemDetail['cost'],
//               cost: Helpers.FormatMoney(itemDetail['cost'], true),
//               maSanPham: itemDetail['newMaSanPham'],
//               serial: itemDetail['newSerial'],
//               totalMoney: 0,
//               totalMoneySum: 0,
//               payedMoney: 0,
//               payedMoneySum: 0,
//               vatAmount: 0,
//               vatAmountSum: 0,
//               tienCong: 0,
//               tienCongSum: 0,
//               countOrder: 0
//             };
//             don.arrOrder.push(detailOrder);
//           }
//         });
//       } else {
//         // nếu chi tiết chưa có thì lấy cái cơ bản
//         don.arrOrder.push(
//           don.num0 === 0
//             ? {
//                 ...don.tempData,
//                 phiGiaHan: 0,
//                 phiGiaHanSum: 0,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 countOrder: 1
//               }
//             : {
//                 ...don.tempData,
//                 phiGiaHan: 0,
//                 phiGiaHanSum: 0,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 totalMoney: 0,
//                 totalMoneySum: 0,
//                 payedMoney: 0,
//                 payedMoneySum: 0,
//                 vatAmount: 0,
//                 vatAmountSum: 0,
//                 tienCong: 0,
//                 tienCongSum: 0,
//                 countOrder: 0
//               }
//         );
//       }
//     } else if (don.type === 'Nâng cấp') {
//       if (don.item.details.length > 0) {
//         don.item.details.forEach((itemDetail, index) => {
//           if (index === 0) {
//             const detailOrder = {
//               ...don.tempData,
//               ...itemDetail,
//               phiGiaHan: 0,
//               phiGiaHanSum: 0,
//               hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//               tienDuKien: don.tempData.payment.tienDuKien,
//               noteDetails: itemDetail['note'],
//               costSum: itemDetail.cost,
//               cost: Helpers.FormatMoney(itemDetail.cost, true),
//               maSanPham: itemDetail.maSanPhamMoi,
//               oldMaSanPham: itemDetail.maSanPhamCu,
//               countOrder: 1
//             };
//             don.arrOrder.push(detailOrder);
//           } else {
//             const detailOrder = {
//               ...don.tempData,
//               ...itemDetail,
//               hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//               tienDuKien: 0,
//               noteDetails: itemDetail['note'],
//               costSum: itemDetail.cost,
//               cost: Helpers.FormatMoney(itemDetail.cost, true),
//               phiGiaHan: 0,
//               phiGiaHanSum: 0,
//               maSanPham: itemDetail.maSanPhamMoi,
//               oldMaSanPham: itemDetail.maSanPhamCu,
//               totalMoney: 0,
//               totalMoneySum: 0,
//               payedMoney: 0,
//               payedMoneySum: 0,
//               vatAmount: 0,
//               vatAmountSum: 0,
//               tienCong: 0,
//               tienCongSum: 0,
//               countOrder: 0
//             };
//             don.arrOrder.push(detailOrder);
//           }
//         });
//       } else {
//         // nếu chi tiết chưa có thì lấy cái cơ bản
//         don.arrOrder.push(
//           don.num0 === 0
//             ? {
//                 ...don.tempData,
//                 phiGiaHan: 0,
//                 phiGiaHanSum: 0,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 countOrder: 1
//               }
//             : {
//                 ...don.tempData,
//                 phiGiaHan: 0,
//                 phiGiaHanSum: 0,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 totalMoney: 0,
//                 totalMoneySum: 0,
//                 payedMoney: 0,
//                 payedMoneySum: 0,
//                 vatAmount: 0,
//                 vatAmountSum: 0,
//                 tienCong: 0,
//                 tienCongSum: 0,
//                 countOrder: 0
//               }
//         );
//       }
//     } else if (don.type === 'Tháo - Lắp lại') {
//       // console.log('thao lap lai', don.tempData,don.item);
//       if (don.item.details?.length > 0) {
//         don.item.details.forEach((itemDetail, index) => {
//           if (index === 0) {
//             const detailOrder = {
//               ...don.tempData,
//               ...itemDetail,
//               phiGiaHan: 0,
//               phiGiaHanSum: 0,
//               hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//               tienDuKien: don.tempData.payment.tienDuKien,
//               noteDetails: itemDetail['note'],
//               costSum: itemDetail.cost,
//               cost: Helpers.FormatMoney(itemDetail.cost, true),
//               companyId: itemDetail.newCompanyId,
//               // oldMaSanPham
//               // oldSerial
//               maSanPham: itemDetail.maSanPham,
//               registrationPlate: itemDetail['newRegistrationPlate'],
//               serial: itemDetail['serial'],
//               countOrder: 1
//               // DeviceList:item.
//             };
//             don.arrOrder.push(detailOrder);
//           } else {
//             const detailOrder = {
//               ...don.tempData,
//               ...itemDetail,
//               hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//               tienDuKien: 0,
//               noteDetails: itemDetail['note'],
//               costSum: itemDetail.cost,
//               phiGiaHan: 0,
//               phiGiaHanSum: 0,
//               cost: Helpers.FormatMoney(itemDetail.cost, true),
//               companyId: itemDetail.newCompanyId,
//               maSanPham: itemDetail.maSanPham,
//               registrationPlate: itemDetail['newRegistrationPlate'],
//               serial: itemDetail['serial'],
//               totalMoney: 0,
//               totalMoneySum: 0,
//               payedMoney: 0,
//               payedMoneySum: 0,
//               vatAmount: 0,
//               vatAmountSum: 0,
//               tienCong: 0,
//               tienCongSum: 0,
//               countOrder: 0
//             };
//             don.arrOrder.push(detailOrder);
//           }
//         });
//       } else {
//         // nếu chi tiết chưa có thì lấy cái cơ bản
//         don.arrOrder.push(
//           don.num0 === 0
//             ? {
//                 ...don.tempData,
//                 phiGiaHan: 0,
//                 phiGiaHanSum: 0,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 countOrder: 1
//               }
//             : {
//                 ...don.tempData,
//                 phiGiaHan: 0,
//                 phiGiaHanSum: 0,
//                 hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
//                 totalMoney: 0,
//                 totalMoneySum: 0,
//                 payedMoney: 0,
//                 payedMoneySum: 0,
//                 vatAmount: 0,
//                 vatAmountSum: 0,
//                 tienCong: 0,
//                 tienCongSum: 0,
//                 countOrder: 0
//               }
//         );
//       }
//     }
//     return don.arrOrder;
//   },

//   formatOneDataOrder: (order: IOrderManager | null | undefined, isReport?: boolean) => {
//     // console.log(' formatOne', order);
//     if (!order) {
//       return null;
//     }
//     // cần qua 1 bước xử lý nữa
//     const tempOrder: any = UtilOrder.formatVarOrder(order);
//     if (
//       order.orderType?.id === 1 ||
//       order.orderType?.id === 2 ||
//       order.orderType?.id === 6 ||
//       order.orderType?.id === 9 ||
//       order.orderType?.id === 10
//     ) {
//       // xử lý phần chi tiết các sản phẩm trong đơn cơ bản
//       let quantityProduct = 0;
//       tempOrder['items'] =
//         order.itemSummaries?.map(item => {
//           quantityProduct += item.quantity;
//           return {
//             ...item,
//             cost: item.cost
//             // details: order.itemDetails // tạm không cần dùng đến dạng sub con này
//           };
//         }) || [];
//       tempOrder['totalProductMix'] = order.itemSummaries?.length;
//       tempOrder['totalProduct'] = quantityProduct;
//       tempOrder['DeviceList'] =
//         order.itemSummaries?.length !== 0
//           ? order.itemSummaries?.map(item => (item.tenSanPham ? item.tenSanPham + '; ' : item.maSanPham + '; '))
//           : [];
//       tempOrder['isDetailLoaded'] = true;
//       // ghi rõ loại đơn, và các serial có liên quan...
//       tempOrder['DetailOrder'] = `${
//         '(' + quantityProduct + ' SP / ' + tempOrder['totalProductMix'] + ' loại) ' + tempOrder['DeviceList']?.join('')
//       }`;

//       // xử lý gom đơn theo bs số cũ => biển số mới
//       // sắp xếp và tiến hành xử lý định dạng và gom dữ liệu lại kèm theo key là BS
//       const tempDetail = [...order.itemDetails].map((item: any, index: number) => ({
//         Bs: item.registrationPlate,
//         child: {
//           ...item
//         }
//       }));

//       // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
//       // lưu ý là phải đúng với format bên form update
//       const mergeList = new Map(tempDetail.map(({ Bs, child }) => [Bs, { Bs, child: [] }]));
//       for (const { Bs, child } of tempDetail) mergeList.get(Bs)?.child.push(...[child].flat());
//       // console.log('mergeList', [...mergeList.values()]);
//       //
//       const tempList: any = [];

//       for (let i = 0; i < [...mergeList.values()]?.length; i++) {
//         let obj = {
//           ...[...mergeList.values()][i]
//         };
//         if ([...mergeList.values()][i].child?.length != 0) {
//           const objDetail: any = [];
//           obj = {
//             ...[...mergeList.values()][i].child[0]
//           };

//           for (let j = 0; j < [...mergeList.values()][i].child.length; j++) {
//             objDetail.push({
//               id: [...mergeList.values()][i].child[j]['id'] || 0,
//               maSanPham: [...mergeList.values()][i].child[j]['maSanPham'] || '',
//               serial: [...mergeList.values()][i].child[j]['serial'] || '',
//               phone: [...mergeList.values()][i].child[j]['phone'] || '',
//               staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',
//               maBo: [...mergeList.values()][i].child[j]['maBo'] || ''
//             });
//           }

//           obj['details'] = objDetail || [];
//           tempList.push(obj);
//         }
//       }
//       // console.log('tempOrder', tempOrder);
//       tempOrder['itemDetailsMerg'] = tempList || [];

//       if (isReport) {
//         // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
//         tempOrder['thoiGianDieuDon'] =
//           order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
//             ?.updateTime === undefined
//             ? ''
//             : new Date(
//                 order?.statusDetails?.find(
//                   staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
//                 )?.updateTime
//               );
//         tempOrder['itemsReport'] =
//           order.itemSummaries
//             ?.map(item => {
//               quantityProduct += item.quantity;
//               return {
//                 ...item,
//                 cost: item.cost,
//                 details: order.itemDetails.sort((a, b) => (a.serial.length != 0 ? -1 : 1)) // chi tiết các xe
//               };
//             })
//             .sort((a, b) => (a.tenSanPham.startsWith('Bộ') ? -1 : 1)) || [];
//         tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
//         tempOrder['StaffCancel'] = order.staffCancel || '';
//         tempOrder['StaffProcesser'] = order.staffComplete || '';
//       }
//     }

//     if (order.orderType?.id === 12) {
//       const details = order.itemDetails || [];

//       // 1. Gom nhóm Plate và xử lý logic gộp không Serial/Phone
//       const groupedByPlate = details.reduce((acc, item) => {
//         const plate = item.registrationPlate;
//         if (!acc[plate]) {
//           acc[plate] = { ...item, details: [] };
//         }

//         const serial = item.serial || '';
//         const phone = item.phone || '';
//         const isGeneric = serial === '' && phone === '';

//         // Tìm xem trong Plate này đã có dòng "không định danh" cùng loại chưa
//         const existingInPlate = isGeneric
//           ? acc[plate].details.find(d => d.maSanPham === item.maSanPham && d.serial === '' && d.phone === '')
//           : null;

//         if (existingInPlate) {
//           existingInPlate.quantity += 1;
//         } else {
//           acc[plate].details.push({
//             ...item,
//             quantity: 1,
//             cost: item.cost || 0
//           });
//         }
//         return acc;
//       }, {});

//       const mergedDetails = Object.values(groupedByPlate);
//       tempOrder['itemDetailsMerg'] = mergedDetails;

//       // 2. Tạo danh sách "Summary" từ Details (Vì không dùng itemSummaries)
//       // Gom tất cả sản phẩm lại để tính tổng Qty và DeviceList
//       const summaryFromDetails = details.reduce((acc, item) => {
//         const key = item.maSanPham;
//         if (!acc[key]) {
//           acc[key] = {
//             maSanPham: item.maSanPham,
//             tenSanPham: item.tenSanPham || item.maSanPham,
//             quantity: 0,
//             cost: item.cost || 0
//           };
//         }
//         acc[key].quantity += 1;
//         return acc;
//       }, {});

//       const finalSummaries = Object.values(summaryFromDetails);
//       const totalQty = details.length;

//       tempOrder['items'] = finalSummaries;
//       tempOrder['totalProductMix'] = finalSummaries.length;
//       tempOrder['totalProduct'] = totalQty;
//       tempOrder['isDetailLoaded'] = true;

//       // 3. Xử lý chuỗi hiển thị
//       const deviceNames = finalSummaries.map(item => `${item.tenSanPham} (${item.quantity}); `);
//       tempOrder['DeviceList'] = deviceNames;
//       tempOrder['DetailOrder'] = `(${totalQty} SP / ${finalSummaries.length} loại) ${deviceNames.join('')}`;

//       // 4. Xử lý dữ liệu Báo cáo (isReport)
//       if (isReport) {
//         const assignStatus = order.statusDetails?.find(s => s.staffBehavior === 'Assign' && s.status === 'Assigned');
//         tempOrder['thoiGianDieuDon'] = assignStatus?.updateTime ? new Date(assignStatus.updateTime) : '';
//         tempOrder['itemsReport'] = finalSummaries
//           .map(s => ({
//             ...s,
//             // Lấy chi tiết của từng loại sản phẩm từ mảng đã gộp ở trên
//             details: mergedDetails
//               .flatMap(p => p.details)
//               .filter(d => d.maSanPham === s.maSanPham)
//               .sort((a, b) => (b.serial?.length || 0) - (a.serial?.length || 0))
//           }))
//           .sort((a, b) => (a.tenSanPham?.startsWith('Bộ') ? -1 : 1));

//         tempOrder['companyNameEx'] = COMPANY_NAMES.find(c => c.value === order.companyName)?.label || '';
//         tempOrder['StaffCancel'] = order.staffCancel || '';
//         tempOrder['StaffProcesser'] = order.staffComplete || '';
//       }
//     }

//     // if (order.orderType?.id === 11) {
//     //   // 1️ Helper chuẩn hóa biển số / serial (phân cách ;)
//     //   const formatStringToDisplay = (val: any) => {
//     //     if (!val) return '';
//     //     return String(val).replace(/;/g, ', ');
//     //   };
//     //   console.log({ order });

//     //   // 2️ Map danh sách đơn nợ mới
//     //   const inDebtOrderCodes = (order.danhSachDonNo || []).map(item => ({
//     //     maDonHang: item.maDonHang || '',
//     //     bienSoXe: formatStringToDisplay(item.bienSoXe),
//     //     serial: formatStringToDisplay(item.serial),

//     //     // Tiền còn nợ (vì chưa có tiềnThucThu nên lấy trực tiếp tienNo)
//     //     tongTienDonNo: Number(item.tienNo || 0),
//     //     tienNo: Number(item.tienNo || 0),

//     //     originalTotal: Number(item.tienNo || 0),

//     //     staffCreate: item.nguoiTao || '',
//     //     checked: true, // mặc định chọn
//     //     soHoaDon: order.soHoaDon || '',
//     //     orderType: item.loai || '',

//     //     goiCuoc: Number(item.goiCuoc || 0),
//     //     type: item.type ?? 1
//     //   }));

//     //   // 3️ Chuẩn hóa list kinh doanh
//     //   const listKinhDoanh = Array.isArray(order.listKinhDoanh)
//     //     ? order.listKinhDoanh.length > 0
//     //       ? order.listKinhDoanh
//     //       : ['']
//     //     : order.listKinhDoanh
//     //     ? [order.listKinhDoanh]
//     //     : [''];

//     //   // 4️ Group lại cho Form.List
//     //   const thuNoGroup = {
//     //     listKinhDoanh: listKinhDoanh,
//     //     inDebtOrderCodes: inDebtOrderCodes,
//     //     soHoaDon: order.soHoaDon || ''
//     //   };

//     //   // 5️ Gán vào tempOrder
//     //   tempOrder['ThuNoItems'] = [thuNoGroup];
//     // }

//     if (order.orderType?.id === 11) {
//       const formatStringToDisplay = (val: any) => {
//         if (!val) return '';
//         return String(val).replace(/;/g, ', ');
//       };

//       // 2️ Xử lý gộp dữ liệu (Grouping) từ Server trả về
//       const groupedDebtOrders = (order.danhSachDonNo || []).reduce((acc: any[], item: any) => {
//         // Tìm nhóm "Hóa Đơn" trùng mã đơn hàng
//         const existingGroup = acc.find(g => g.maDonHang === item.maDonHang && item.loai === 'Hóa đơn');

//         const processedItem = {
//           maDonHang: item.maDonHang || '',
//           bienSoXe: formatStringToDisplay(item.bienSoXe),
//           serial: formatStringToDisplay(item.serial),
//           tongTienDonNo: Number(item.tienNo || 0),
//           tienNo: Number(item.tienNo || 0),
//           originalTotal: Number(item.tienNo || 0),
//           // Map đúng tên field "nguoiTao" và "ngay" như trong Form.List của component
//           nguoiTao: item.nguoiTao || '',
//           ngay: item.ngayHoanThanh || item.ngay ? moment(item.ngayHoanThanh || item.ngay).format('DD/MM/YYYY') : '-',
//           checked: true,
//           orderType: item.loai || '',
//           goiCuoc: Number(item.goiCuoc || 0),
//           thuVat: Number(item.thuVat || 0),
//           thuGoiCuoc: Number(item.thuGoiCuoc) || 0,
//           thuChenhLech: Number(item.thuChenhLech || 0),
//           type: item.type ?? 1,
//           id: item.id
//         };

//         if (item.loai === 'Hóa đơn') {
//           // Tìm nhóm đã tồn tại dựa trên mã đơn hàng
//           const existingGroup = acc.find(g => g.maDonHang === item.maDonHang && g.orderType === 'Hóa đơn');

//           if (!existingGroup) {
//             // Khởi tạo nhóm mới
//             acc.push({
//               ...processedItem,
//               isGroup: true,
//               childItems: [{ ...processedItem }] // Khởi tạo mảng con
//             });
//           } else {
//             // 1. Cộng dồn giá trị số
//             existingGroup.tienNo += processedItem.tienNo;
//             existingGroup.tongTienDonNo += processedItem.tongTienDonNo;
//             existingGroup.goiCuoc += processedItem.goiCuoc;
//             existingGroup.thuVat += processedItem.thuVat;
//             existingGroup.thuChenhLech += processedItem.thuChenhLech;

//             // 2. Gộp chuỗi (Biển số & Serial) - Dùng hàm helper cho sạch code
//             const mergeStrings = (oldStr: string, newStr: string) => {
//               const combined = [...(oldStr?.split(', ') || []), ...(newStr?.split(', ') || [])];
//               return Array.from(new Set(combined)).filter(Boolean).join(', ');
//             };

//             existingGroup.bienSoXe = mergeStrings(existingGroup.bienSoXe, processedItem.bienSoXe);
//             existingGroup.serial = mergeStrings(existingGroup.serial, processedItem.serial);

//             // 3. QUAN TRỌNG: Push vào mảng con (Bỏ comment và thêm check an toàn)
//             if (!existingGroup.childItems) existingGroup.childItems = [];
//             existingGroup.childItems.push(processedItem);
//           }
//         } else {
//           // Không phải Hóa đơn thì thêm mới như một dòng độc lập
//           acc.push({ ...processedItem, isGroup: false, childItems: [] });
//         }
//         return acc;
//       }, []);

//       // 3️ Chuẩn hóa list kinh doanh (Xử lý mảng rỗng để tránh lỗi [""])
//       const listKinhDoanh = Array.isArray(order.listKinhDoanh)
//         ? order.listKinhDoanh.length > 0
//           ? order.listKinhDoanh
//           : ['']
//         : order.listKinhDoanh
//         ? [order.listKinhDoanh]
//         : [''];

//       // 4️ Gán vào ThuNoItems
//       tempOrder['ThuNoItems'] = [
//         {
//           listKinhDoanh: listKinhDoanh,
//           inDebtOrderCodes: groupedDebtOrders,
//           soHoaDon: order.soHoaDon || ''
//         }
//       ];
//     }

//     if (order.orderType?.id === 13) {
//       // 1. Đảm bảo dữ liệu luôn là mảng để tránh lỗi
//       const listKDArray = Array.isArray(order.listKinhDoanh) ? order.listKinhDoanh : [];
//       const diffArray = Array.isArray(order.diff) ? order.diff : [];

//       // 2. Tạo mảng chứa 1 object duy nhất gộp cả 2 thông tin
//       const tempList = [
//         {
//           listKinhDoanh: listKDArray,
//           diff: diffArray
//         }
//       ];

//       // 3. Gán vào object tổng
//       tempOrder['ChenhLechItems'] = tempList;
//     }

//     if (order.orderType?.id === 3) {
//       const tempDetail = [...order.collectingFeeInfo.detail].map((item: any, index: number) => ({
//         Bs: item.bs,
//         child: {
//           ...item
//         }
//       }));
//       // chỗ này cần tách theo mã cũ => mã mới + Bs theo // gộp theo BS như này là chưa đủ! => có trường hợp 1 xe nâng cấp nhiều thứ
//       // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
//       // lưu ý là phải đúng với format bên form update
//       const mergeList = new Map(tempDetail.map(({ Bs, child }) => [Bs, { Bs, child: [] }]));
//       for (const { Bs, child } of tempDetail) mergeList.get(Bs)?.child.push(...[child].flat());
//       console.log('mergeList', [...mergeList.values()]);
//       //
//       const tempList: any = [];

//       for (let i = 0; i < [...mergeList.values()]?.length; i++) {
//         let obj = {};
//         // kiểm tra coi nếu như có mã sản phẩm cũ thì mã cũ này add nó vào list tổng sản phẩm
//         if ([...mergeList.values()][i].child?.length != 0) {
//           const objDetail: any = [];
//           // ẩn này vì bên ngoài có rồi
//           for (let j = 0; j < [...mergeList.values()][i].child?.length; j++) {
//             if ([...mergeList.values()][i].child[j]['type'] == 0) {
//               obj = { ...[...mergeList.values()][i].child[j] };
//             } else {
//               objDetail.push({
//                 id: [...mergeList.values()][i].child[j]['id'] || 0,
//                 maSanPham: [...mergeList.values()][i].child[j]['maSanPham'] || '',
//                 serial: [...mergeList.values()][i].child[j]['serial'] || '',
//                 phone: [...mergeList.values()][i].child[j]['phone'] || '',
//                 cost: [...mergeList.values()][i].child[j]['cost'] || 0,
//                 old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
//                 // maBo: [...mergeList.values()][i].child[j]['maBo'] || ''
//               });
//             }
//           }

//           obj['details'] = objDetail || [];
//           // obj['products'] = objProduct || [];
//           tempList.push(obj);
//         }

//         tempOrder['payFees'] = tempList;
//       }

//       // chi tiết sp trong đơn thu phí
//       tempOrder['tienCongSum'] = order.payment.chiPhiPhatSinh + order.payment.tienDuKien;
//       tempOrder['tienCong'] = Helpers.FormatMoney(order.payment.chiPhiPhatSinh + order.payment.tienDuKien, true);
//       tempOrder['thoiGianDongPhi'] = order.collectingFeeInfo.thoiGianDongPhi;
//       tempOrder['thoiGianHetHan'] = order.collectingFeeInfo.thoiGianHetHan;
//       tempOrder['month'] = order.collectingFeeInfo.month;
//       // tempOrder['payFees'] = order.collectingFeeInfo.detail;
//       tempOrder['CompanyName'] = order.collectingFeeInfo.companyName;
//       tempOrder['DeviceList'] = order.collectingFeeInfo.detail || [];
//       tempOrder['DetailOrder'] = `${'T.Phí ' + (tempOrder['DeviceList']?.length || 0) + ' xe'}`;
//       tempOrder['isDetailLoaded'] = true;
//       if (isReport) {
//         // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
//         tempOrder['thoiGianDieuDon'] =
//           order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
//             ?.updateTime === undefined
//             ? ''
//             : new Date(
//                 order?.statusDetails?.find(
//                   staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
//                 )?.updateTime
//               );
//         tempOrder['itemsReport'] = [{ details: order.collectingFeeInfo.detail }];
//         tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
//         tempOrder['StaffCancel'] = order.staffCancel || '';
//         tempOrder['StaffProcesser'] = order.staffComplete || '';
//       }
//     }
//     if (order.orderType?.id === 4 || order.orderType?.id === 5) {
//       // chi tiết sp trong đơn sửa chữa bảo hành
//       // warranty
//       // repairingInfo
//       tempOrder['tienCongSum'] = order.payment.chiPhiPhatSinh + order.payment.tienDuKien;
//       tempOrder['tienCong'] = Helpers.FormatMoney(order.payment.chiPhiPhatSinh + order.payment.tienDuKien, true);

//       tempOrder['warranty'] = order.warranty;
//       tempOrder['errorList'] = order.repairingInfo.map(error => ({
//         ...error,
//         cost: error.cost
//       }));
//       tempOrder['DeviceList'] = true;
//       tempOrder['DetailOrder'] = `${'S.Chữa | B.Hành ' + (order.repairingInfo?.length || 0) + ' bộ'}`;
//       tempOrder['isDetailLoaded'] = true;

//       // let quantityDevice = 0;
//       // không cn dùng nên tạm ẩn để đây
//       // tempOrder['upgrades'] =
//       //   order.upgradeSummaries?.map(item => {
//       //     const listDetail = order.upgradeDetails.filter(
//       //       itemDF => itemDF.maSanPhamCu === item.maSanPhamCu && itemDF.maSanPhamMoi === item.maSanPhamMoi
//       //     );
//       //     quantityDevice += item.quantity;
//       //     return {
//       //       ...item,
//       //       details: listDetail
//       //     };
//       //   }) || [];
//       // khởi tạo hàm gom nhóm sản phẩm theo bs đôi với đơn nâg cấp này
//       // xử lý gom đơn theo bs số cũ => biển số mới
//       // sắp xếp và tiến hành xử lý định dạng và gom dữ liệu lại kèm theo key là BS
//       const tempDetail = [...order.repairingInfo].map((item: any, index: number) => ({
//         Bs: item.registrationPlate + item.phenomenon + item.errorTpye,
//         //  + item.phenomenon + item.diagnosis + item.errorTpye,
//         child: {
//           ...item
//         }
//       }));
//       // chỗ này cần tách theo mã cũ => mã mới + Bs theo // gộp theo BS như này là chưa đủ! => có trường hợp 1 xe nâng cấp nhiều thứ
//       // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
//       // lưu ý là phải đúng với format bên form update
//       const mergeList = new Map(tempDetail.map(({ Bs, child }) => [Bs, { Bs, child: [] }]));
//       for (const { Bs, child } of tempDetail) mergeList.get(Bs)?.child.push(...[child].flat());
//       // console.log('  mergeList', [...mergeList.values()]);
//       //
//       const tempList: any = [];

//       for (let i = 0; i < [...mergeList.values()]?.length; i++) {
//         const obj = { ...[...mergeList.values()][i].child[0] };
//         // kiểm tra coi nếu như có mã sản phẩm cũ thì mã cũ này add nó vào list tổng sản phẩm
//         if ([...mergeList.values()][i].child?.length != 0) {
//           const objDetail: any = [];
//           const objError: any = [];

//           // ẩn này vì bên ngoài có rồi
//           for (let j = 0; j < [...mergeList.values()][i].child?.length; j++) {
//             const rawDiagnosis = [...mergeList.values()][i].child[j]['diagnosis'];
//             const rawHandling = [...mergeList.values()][i].child[j]['handling'];

//             const newDiagnosis = rawDiagnosis ? rawDiagnosis.split(';') : [];
//             const newHandling = rawHandling ? rawHandling.split(';') : [];

//             const mapDiagnosis = {};

//             for (let k = 0; k < newDiagnosis.length; k++) {
//               const diag = newDiagnosis[k]?.trim();
//               const hand = newHandling[k]?.trim();

//               if (!diag) continue;

//               if (!mapDiagnosis[diag]) {
//                 mapDiagnosis[diag] = [];
//               }

//               if (hand && !mapDiagnosis[diag].includes(hand)) {
//                 mapDiagnosis[diag].push(hand);
//               }
//             }
//             for (const diag of Object.keys(mapDiagnosis)) {
//               const existing = objError.find(item => item.newDiagnosis === diag);

//               if (existing) {
//                 // Gộp thêm handling nếu chưa có
//                 for (const h of mapDiagnosis[diag]) {
//                   if (!existing.newHandling.includes(h)) {
//                     existing.newHandling.push(h);
//                   }
//                 }
//               } else {
//                 // Chưa có thì push mới
//                 objError.push({
//                   newDiagnosis: diag,
//                   newHandling: [...mapDiagnosis[diag]] // dùng spread để tránh tham chiếu
//                 });
//               }
//             }
//             // console.log('merlist', [...mergeList.values()][i].child[j]);

//             if (!([...mergeList.values()][i].child[j]['newMaSanPham'] == '')) {
//               // && tempOrder.status.statusValue == '4'
//               // hoàn tất thì bỏ đi những cái có newMaSanPham là string rỗng
//               objDetail.push({
//                 id: [...mergeList.values()][i].child[j]['id'] || 0,
//                 newMaSanPham: [...mergeList.values()][i].child[j]['newMaSanPham'] || '',
//                 newSerial: [...mergeList.values()][i].child[j]['newSerial'] || '',
//                 newPhone: [...mergeList.values()][i].child[j]['newPhone'] || '',
//                 staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',
//                 staffCreate: [...mergeList.values()][i].child[j]['staffCreate'] || '',
//                 cost: [...mergeList.values()][i].child[j]['cost'] || 0,
//                 note: [...mergeList.values()][i].child[j]['note'] || '',
//                 old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
//                 // maBo: [...mergeList.values()][i].child[j]['maBo'] || ''
//               });
//             }
//           }
//           obj['details'] = objDetail || [];
//           obj['errors'] = objError || [];
//           // obj['products'] = objProduct || [];
//           tempList.push(obj);
//         }
//         tempOrder['itemsRepair'] = tempList;
//       }
//       if (isReport) {
//         // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
//         tempOrder['thoiGianDieuDon'] =
//           order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
//             ?.updateTime === undefined
//             ? ''
//             : new Date(
//                 order?.statusDetails?.find(
//                   staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
//                 )?.updateTime
//               );
//         tempOrder['itemsReport'] = [{ details: order.repairingInfo }];
//         tempOrder['StaffCancel'] = order.staffCancel || '';
//         tempOrder['StaffProcesser'] = order.staffComplete || '';
//         tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
//       }
//       console.log('tempOrder', tempOrder);
//     }
//     if (order.orderType?.id === 7) {
//       // chi tiết sp trong đơn nâng cấp
//       // upgradeSummaries
//       // upgradeDetails
//       // upgrades

//       tempOrder['tienCong'] = Helpers.FormatMoney(order.payment.chiPhiPhatSinh + order.payment.tienDuKien, true);
//       tempOrder['tienCongSum'] = order.payment.chiPhiPhatSinh + order.payment.tienDuKien;

//       tempOrder['upgradeSummaries'] = order.upgradeSummaries;
//       tempOrder['upgradeDetails'] = order.upgradeDetails;
//       // tempOrder['upgradeProducts'] = order.upgradeProducts;
//       tempOrder['isDetailLoaded'] = true;
//       let quantityDevice = 0;
//       // không cn dùng nên tạm ẩn để đây
//       // tempOrder['upgrades'] =
//       //   order.upgradeSummaries?.map(item => {
//       //     const listDetail = order.upgradeDetails.filter(
//       //       itemDF => itemDF.maSanPhamCu === item.maSanPhamCu && itemDF.maSanPhamMoi === item.maSanPhamMoi
//       //     );
//       //     quantityDevice += item.quantity;
//       //     return {
//       //       ...item,
//       //       details: listDetail
//       //     };
//       //   }) || [];
//       // khởi tạo hàm gom nhóm sản phẩm theo bs đôi với đơn nâg cấp này
//       // xử lý gom đơn theo bs số cũ => biển số mới
//       // sắp xếp và tiến hành xử lý định dạng và gom dữ liệu lại kèm theo key là BS
//       const tempDetail = [...order.upgradeDetails].map((item: any, index: number) => ({
//         Bs: item.registrationPlate,
//         child: {
//           ...item
//         }
//       }));
//       // chỗ này cần tách theo mã cũ => mã mới + Bs theo // gộp theo BS như này là chưa đủ! => có trường hợp 1 xe nâng cấp nhiều thứ
//       // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
//       // lưu ý là phải đúng với format bên form update
//       const mergeList = new Map(tempDetail.map(({ Bs, child }) => [Bs, { Bs, child: [] }]));
//       for (const { Bs, child } of tempDetail) mergeList.get(Bs)?.child.push(...[child].flat());
//       // console.log('mergeList', [...mergeList.values()]);
//       //
//       const tempList: any = [];

//       for (let i = 0; i < [...mergeList.values()]?.length; i++) {
//         const obj = { ...[...mergeList.values()][i].child[0] };
//         // kiểm tra coi nếu như có mã sản phẩm cũ thì mã cũ này add nó vào list tổng sản phẩm
//         if ([...mergeList.values()][i].child?.length != 0) {
//           const objDetail: any = [];
//           const objProduct: any = [];
//           // ẩn này vì bên ngoài có rồi
//           for (let j = 0; j < [...mergeList.values()][i].child?.length; j++) {
//             // bước bỏ đi các sản phẩm k có mã cũ => đây là các sản phâm phụ thêm vào cho xe này
//             if (
//               ![...mergeList.values()][i].child[j]['maSanPhamCu'] ||
//               [...mergeList.values()][i].child[j]['maSanPhamCu']?.length == 0
//             )
//               objDetail.push({
//                 id: [...mergeList.values()][i].child[j]['id'] || 0,
//                 maSanPham: [...mergeList.values()][i].child[j]['maSanPhamMoi'] || '',
//                 serial: [...mergeList.values()][i].child[j]['serial'] || '',
//                 phone: [...mergeList.values()][i].child[j]['phone'] || '',
//                 staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',
//                 staffCreate: [...mergeList.values()][i].child[j]['staffCreate'] || '',
//                 cost: [...mergeList.values()][i].child[j]['cost'] || 0,
//                 old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
//                 // maBo: [...mergeList.values()][i].child[j]['maBo'] || ''
//               });
//             else {
//               objProduct.push({
//                 id: [...mergeList.values()][i].child[j]['id'] || 0,
//                 maSanPhamCu: [...mergeList.values()][i].child[j]['maSanPhamCu'] || '',
//                 maSanPhamMoi: [...mergeList.values()][i].child[j]['maSanPhamMoi'] || '',
//                 preMaSanPham: [...mergeList.values()][i].child[j]['maSanPhamMoi'] || '',
//                 serial: [...mergeList.values()][i].child[j]['serial'] || '',
//                 phone: [...mergeList.values()][i].child[j]['phone'] || '',
//                 serialCu: [...mergeList.values()][i].child[j]['serialCu'] || '',
//                 phoneCu: [...mergeList.values()][i].child[j]['phoneCu'] || '',
//                 staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',
//                 staffCreate: [...mergeList.values()][i].child[j]['staffCreate'] || '',
//                 cost: [...mergeList.values()][i].child[j]['cost'] || 0,
//                 old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
//               });

//               quantityDevice += 1;
//             }
//           }

//           obj['details'] = objDetail || [];
//           obj['products'] = objProduct || [];
//           tempList.push(obj);
//         }
//       }
//       tempOrder['DeviceList'] = true;
//       tempOrder['totalUpgrade'] = quantityDevice;
//       tempOrder['DetailOrder'] = `${
//         'N.Cấp ' + (quantityDevice || 0) + ' xe' + ' ' + order.upgradeDetails?.length + ' SP'
//       }`;

//       // console.log('tempList', tempList);
//       tempOrder['itemUpgradesMerg'] = tempList;

//       if (isReport) {
//         tempOrder['thoiGianDieuDon'] =
//           order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
//             ?.updateTime === undefined
//             ? ''
//             : new Date(
//                 order?.statusDetails?.find(
//                   staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
//                 )?.updateTime
//               );
//         // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
//         tempOrder['itemsReport'] = [{ details: order.upgradeDetails }];
//         tempOrder['StaffCancel'] = order.staffCancel || '';
//         tempOrder['StaffProcesser'] = order.staffComplete || '';
//         tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
//       }
//     }

//     if (order.orderType?.id === 8) {
//       // chi tiết sp trong đơn tháo
//       tempOrder['isDetailLoaded'] = true;
//       tempOrder['tienCongSum'] = order.payment.chiPhiPhatSinh + order.payment.tienDuKien;
//       tempOrder['tienCong'] = Helpers.FormatMoney(order.payment.chiPhiPhatSinh + order.payment.tienDuKien, true);

//       // xử lý gom đơn theo bs số cũ => biển số mới
//       // sắp xếp và tiến hành xử lý định dạng và gom dữ liệu lại kèm theo key là BS
//       const tempDetail =
//         order?.orderDetails?.map((item: any, index: number) => ({
//           BsRL: item.oldRegistrationPlate + '=' + item.newRegistrationPlate,
//           child: {
//             ...item
//           }
//         })) || [];

//       // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
//       // lưu ý là phải đúng với format bên form update
//       const mergeList = new Map(tempDetail?.map(({ BsRL, child }) => [BsRL, { BsRL, child: [] }]));
//       for (const { BsRL, child } of tempDetail) mergeList?.get(BsRL)?.child.push(...[child].flat());
//       const tempList: any = [];

//       for (let i = 0; i < [...mergeList.values()]?.length; i++) {
//         let obj = {
//           ...[...mergeList.values()][i]
//         };
//         if ([...mergeList.values()][i].child?.length != 0) {
//           const objDetail: any = [];
//           const objProduct: any = [];
//           obj = {
//             ...[...mergeList.values()][i].child[0]
//           };

//           for (let j = 0; j < [...mergeList.values()][i].child?.length; j++) {
//             const obj = {
//               id: [...mergeList.values()][i].child[j]['id'] || 0,
//               cost: [...mergeList.values()][i].child[j]['cost'] || 0,
//               maSanPham: [...mergeList.values()][i].child[j]['maSanPham'] || '',
//               phone: [...mergeList.values()][i].child[j]['phone'] || '',
//               serial: [...mergeList.values()][i].child[j]['serial'] || '',
//               maSanPhamMoi: [...mergeList.values()][i].child[j]['maSanPhamMoi'] || '',
//               phoneMoi: [...mergeList.values()][i].child[j]['phoneMoi'] || '',
//               serialMoi: [...mergeList.values()][i].child[j]['serialMoi'] || '',
//               note: [...mergeList.values()][i].child[j]['note'] || '',
//               staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',

//               old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
//             };
//             if ([...mergeList.values()][i].child[j]['maSanPham'] == '') {
//               // mã cũ là rỗng nghĩa là sp bán thêm mới nằm trong list chi tiết
//               objDetail.push(obj);
//             } else {
//               // mã cũ có thì là sản phẩm chính tháo lắp nên để trong product
//               objProduct.push(obj);
//             }
//           }

//           obj['details'] = objDetail || [];
//           obj['products'] = objProduct || [];
//           tempList.push(obj);
//         }
//       }
//       tempOrder['replaces'] = tempList || [];

//       const quantityDevice = tempOrder.replaces?.length;
//       tempOrder['DeviceList'] = true;
//       tempOrder['totalReplace'] = quantityDevice;
//       tempOrder['DetailOrder'] = `${'Tháo.Lắp lại ' + (quantityDevice || 0) + ' bộ'}`;

//       if (isReport) {
//         // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
//         tempOrder['thoiGianDieuDon'] =
//           order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
//             ?.updateTime === undefined
//             ? ''
//             : new Date(
//                 order?.statusDetails?.find(
//                   staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
//                 )?.updateTime
//               );
//         tempOrder['itemsReport'] = [{ details: order.orderDetails }];
//         tempOrder['StaffCancel'] = order.staffCancel || '';
//         tempOrder['StaffProcesser'] = order.staffComplete || '';
//         tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
//       }
//     }

//     return tempOrder;
//   },

//   convertIdTypeOrderToNameAPI: (oderTypeId: number) => {
//     switch (oderTypeId) {
//       case 1:
//       case 2:
//       case 6:
//       case 10: // đơn lắp giùm đly
//         return 'GLD'; // đơn gửi, lắp hoặc thu đổi
//       case 4:
//       case 5:
//         return 'SB'; // đơn sửa chữa bảo hành
//       case 3:
//         return 'TP'; // đơn thu phí
//       case 7:
//         return 'NC'; // đơn nâng cấp
//       case 8:
//         return 'TH'; // đơn tháo - lắp lại
//       case 9:
//         return 'DLL'; // đơn đại lý lắp dùm
//       case 11:
//         return 'TN'; // đơn thu nợ
//       case 12:
//         return 'THang'; // đơn trả hàng
//       case 13:
//         return 'ChenhLech'; // đơn chênh lệch
//       case 14:
//         return 'HoanTien'; // đơn hoàn tiền
//       default:
//         return '';
//     }
//   },

//   makeDetailBase: (valueQuick: any, maSanPham: any, amount: any) => {
//     const tempDetail: any[] = [];
//     if (valueQuick?.length != 0) {
//       // thêm theo bộ
//       for (let i = 0; i < amount; i++) {
//         for (let j = 0; j < valueQuick?.length; j++) {
//           const aDetail = {
//             id: crypto.randomUUID(),
//             maSanPham: valueQuick[j] || undefined,
//             serial: undefined,
//             phone: undefined,
//             maBo: maSanPham || ''
//           };
//           tempDetail.push(aDetail);
//         }
//       }
//     } else {
//       for (let i = 0; i < amount; i++) {
//         const aDetail = {
//           id: crypto.randomUUID(),
//           maSanPham: maSanPham || undefined,
//           phone: undefined,
//           serial: undefined,
//           maBo: ''
//         };
//         tempDetail.push(aDetail);
//       }
//     }

//     return [...tempDetail];
//   },

//   handleCalSumByDetail: (data: any, preDevice: any) => {
//     const listDevices: any = [];
//     const listPrice: any = [];

//     for (let i = 0; i < data?.length; i++) {
//       for (let j = 0; j < data[i].details?.length; j++) {
//         listDevices.push(data[i].details[j].maSanPham);
//         listPrice.push(preDevice.find(preP => preP.maSanPham == data[i].details[j].maSanPham)?.cost || null);
//       }
//     }

//     return {
//       devices: listDevices,
//       quantities: null,
//       price: listPrice
//     };
//   }
// };

// export default UtilOrder;

import { ICustomer } from '@models/Customer';
import { IOrderManager, statusDetail } from '@models/OrderManager';
import { COMPANY_NAMES, Cancel, ConfirmWait, InHold, InProcess, Pause, Success } from 'global/Global';
import Helpers from 'helpers/Helpers';
import { IDetailsItem } from 'models/CreateOrder';
import { IProductCategory } from 'models/StockManage/CateProductManage';
import moment from 'moment';

import React, { useState } from 'react';

export const convertTime = {
  days7: `${moment().subtract(6, 'd').format('YYYY-MM-DD')}T00:00:00.000Z`,
  begin: `${moment().year()}-${
    moment().month() + 1 < 10 ? `0${moment().month() + 1}` : `${moment().month() + 1}`
  }-${moment().date()}T00:00:00.000Z`,
  end: `${moment().year()}-${
    moment().month() + 1 < 10 ? `0${moment().month() + 1}` : `${moment().month() + 1}`
  }-${moment().date()}T23:59:59.000Z`
};

export const defaultMoney = {
  totalMoney: 0,
  totalMoneySum: 0,
  payedMoney: 0,
  payedMoneySum: 0,
  vatAmount: 0,
  vatAmountSum: 0
};
// interface IUtilOrder
export interface IUtilOrder {
  /**
   * Tăng SL sản phẩm
   */
  upQuantity: (itemUQ: IProductCategory, data: Array<IProductCategory>) => Array<IProductCategory>;

  /**
   * Giảm  SL sản phẩm
   * @param
   * @returns
   */
  downQuantity: (itemDQ: IProductCategory, data: Array<IProductCategory>) => Array<IProductCategory>;

  /**
   * Thay đổi giá sản phẩm
   * @param
   * @param
   * @returns
   */
  changePrice: (
    value: React.ChangeEvent<HTMLInputElement>,
    itemP: IProductCategory,
    data: Array<IProductCategory>
  ) => Array<IProductCategory>;

  /**
   * Thay đổi item chi tiết
   * @param
   * @param
   * @returns
   */
  addDetailToItem: (
    serial: string,
    Bs: string,
    vehicleType: string,
    data: IProductCategory,
    dataList: Array<IProductCategory>,
    isUpdate?: boolean
  ) => Array<IProductCategory>;

  /**
   * Xoá Item in detail Item list
   * @param
   * @param
   * @returns
   */
  deleteDetailItem: (
    itemD: IDetailsItem,
    data: IProductCategory,
    dataList: Array<IProductCategory>
  ) => Array<IProductCategory>;

  /**
   * Thay đổi item chi tiết số lượng lớn
   * @param
   * @param
   * @returns
   */
  addQuickDetailToItem: (
    startSerial: string,
    data: IProductCategory,
    dataList: Array<IProductCategory>,
    amount: number
  ) => Array<IProductCategory>;

  /**
   * Thay đổi số lượng sản phẩm
   * @param
   * @param
   * @returns
   */
  changeQuantity: (
    value: React.ChangeEvent<HTMLInputElement>,
    itemQ: IProductCategory,
    data: Array<IProductCategory>
  ) => Array<IProductCategory>;

  /**
   * Thay đổi số lượng sản phẩm
   * @param
   * @param
   * @returns
   */
  sumPriceFormat: (price: number, quantity: number) => string;

  /**
   * Chuyển trạng thái đơn dạng string text từ server sang dạng string number và kèm màu sắc để dùng dưới client
   * có kièm theo language
   * @return {
   * text: language,
   * value: string dạng số 1,2...
   * color: string
   * }
   */
  convertStatusTextToStatusClient: (currentStatus: string, operatorSeen?: boolean) => any;

  convertOrderType: (type: any) => any;
  /**
   * Hàm phân loại đơn có phải thuộc tab quản lý hay không
   * @param valueStatus giá trị hiện tại cần phân loại ra
   * @returns trả về string là dạng loại đơn
   */
  classificationOrder: (valueStatus?: string) => any;
  // Hàm lấy trạng thái của đơn
  listCurrentStatus: (arrayCurrentStatus?: any) => any;
  /**
   * Chuyển về format tiền + sản phẩm đơn hàng để hiển thị trong table ql đơn
   */
  moneyTotalOrderFormat: (items: any) => string;

  formatVarOrder: (orders: IOrderManager) => IOrderManager;
  formatVarCustomer: (customers: ICustomer) => ICustomer;

  /**
   * Chuyển dữ liệu đơn sau khi nhận từ server về đúng dạng cần thiết
   * đếm số lượng đơn theo trạng thái rồi trả về tại hàm này luôn !!!
   */
  formatDataOrders: (orders: any[]) => any;
  formatDataCustomers: (customers: any[]) => any;

  /**
   * Đếm số lượng đơn theo trạng thái rồi trả về các tổng trạng thái tương ứng !!!
   */
  countOrders: (orders: IOrderManager[]) => any;
  /**
   * Truyền key lấy dữ liệu giới hạn tiền  !!!
   */
  getDataOMConfig: (datas, key) => any;

  /**
   * Chuyển dữ liệu của 1 đơn hàng từ dạng đơn cơ bản sang dạng đơn chi tiết nhất (dữ liệu đầy đủ nhất)
   *
   */
  formatOneDataOrder: (order: any, isReport?: boolean) => any;

  formatCacLoaiDon: (don: any) => any;

  /**
   * Hàm chuyển id đơn hàng sang mẫu text để gọi api
   * @param oderTypeId number id loại đơn hàng
   * @returns
   */
  convertIdTypeOrderToNameAPI: (oderTypeId: number) => any;

  /**
   * Hàm tạo list detail sản phẩm
   * @param valueQuick list thêm bộ rã ra sản phẩm bên trong
   * @param maSanPham mã sp gốc đã chọn
   * @param amount sl tb cần add vào
   * @returns arr sản phẩm
   */
  makeDetailBase: (valueQuick: any, maSanPham: any, amount: any) => any;

  /**
   * Hàm tạo summary từ detail đã thêm tay vào, hiện đang dùng cho đơn ĐL lắp giùm
   * @param data list detail các sản phẩm của đơn từng xe
   * @param preDevice danh sách thiết bị hiện tại có giá => lấy giá để dùng lại
   * @returns 1 obj arr devices, quantities, price dùng để tạo lại dữ liệu cho store devices
   */
  handleCalSumByDetail: (data: any, preDevice: any) => any;
}

const UtilOrder: IUtilOrder = {
  upQuantity: (itemUQ: IProductCategory, data: Array<IProductCategory>) => {
    return data.map((item: IProductCategory) => {
      if (item.name === itemUQ.name) return { ...item, Quantity: item.Quantity! + 1 };
      return { ...item };
    });
  },

  downQuantity: (itemDQ: IProductCategory, data: Array<IProductCategory>) => {
    return data.map((item: IProductCategory) => {
      if (item.name === itemDQ.name && itemDQ.Quantity! > 1) return { ...item, Quantity: item.Quantity! - 1 };
      return { ...item };
    });
  },

  changePrice: (value: React.ChangeEvent<HTMLInputElement>, itemP: IProductCategory, data: Array<IProductCategory>) => {
    const tempValueCovert = value.target.value.toString().replaceAll(',', '');
    // console.log(
    //   'changePrice',
    //   itemP,
    //   tempValueCovert,
    //   data,
    //   Helpers.isNumeric(tempValueCovert) && Number(tempValueCovert) >= 0
    // );
    const valueSet = Helpers.isNumeric(tempValueCovert) && Number(tempValueCovert) > 0 ? Number(tempValueCovert) : 0;

    return data.map((item: IProductCategory) => {
      // console.log('map', item.name, itemP.name, Number(tempValueCovert));
      if (item.name === itemP.name) return { ...item, priceMuch: valueSet, giaBanSi: valueSet };
      return { ...item };
    });
  },

  changeQuantity: (
    value: React.ChangeEvent<HTMLInputElement>,
    itemQ: IProductCategory,
    data: Array<IProductCategory>
  ) => {
    if (Helpers.isNumeric(value.target.value) && Number(value.target.value) > 0) {
      return data.map((item: IProductCategory) => {
        if (item.name === itemQ.name) return { ...item, Quantity: Number(value.target.value) };
        return { ...item };
      });
    }
    return data;
  },

  deleteDetailItem: (itemD: IDetailsItem, data: IProductCategory, dataList: Array<IProductCategory>) => {
    return dataList.map(item => {
      if (item.name === data.name) {
        const newDetails = item.details?.filter(itemF => itemF.maSanPham !== itemD.maSanPham);

        return { ...item, details: newDetails };
      }
      return { ...item };
    });
  },
  addDetailToItem: (
    serial: string,
    Bs: string,
    vehicleType: string,
    data: IProductCategory,
    dataList: Array<IProductCategory>,
    isUpdate?: boolean
  ) => {
    let isStop = false;

    const arrProcess = dataList.map((item: IProductCategory) => {
      if (item.name === data.name && item.requireDetail) {
        if (isUpdate === true) {
          let newArrOC;
          item.details?.map(itemA => {
            if (itemA.maSanPham === serial) {
              // đã tồn tại serial => thay itemA bằng tempO
              newArrOC = item.details?.map(object => {
                if (object.maSanPham === serial) {
                  return { ...object, vehicleType: vehicleType, registrationPlate: Bs };
                }
                return object;
              });
            }
          });

          return { ...item, details: newArrOC };
        }
        item.details?.map(itemA => {
          if (itemA.maSanPham === serial) {
            // đã tồn tại serial => từ chối thao tác
            isStop = true;
          }
        });

        const tempO = { maSanPham: serial, vehicleType: vehicleType, registrationPlate: Bs };
        // thêm mới
        const addArrOA = item.details && [...item.details, tempO];

        return {
          ...item,
          details: addArrOA
        };
      }
      return { ...item };
    });

    if (isStop) return [];
    return arrProcess;
  },

  addQuickDetailToItem: (
    startSerial: string,
    data: IProductCategory,
    dataList: Array<IProductCategory>,
    amount: number
  ) => {
    let isStop = false;
    const arrProcess = dataList.map((item: IProductCategory) => {
      if (item.name === data.name && item.requireDetail) {
        let startSerialNext = Number(startSerial);
        let i = 0;
        const arraySerial: string[] = [];
        while (i < amount) {
          item.details?.map(itemA => {
            if (Number(itemA.maSanPham) === startSerialNext) {
              // đã tồn tại serial => từ chối thao tác
              isStop = true;
            }
          });
          arraySerial.push(Number(startSerialNext).toString());
          startSerialNext += 1;
          i += 1;
        }
        const tempO = arraySerial.map(item => ({
          maSanPham: item
        }));
        const addArrOA = item.details && [...item.details, ...tempO];
        return {
          ...item,
          details: addArrOA
        };
      }
      return { ...item };
    });

    if (isStop) return [];
    return arrProcess;
  },

  sumPriceFormat: (price: number, quantity: number) => {
    const sumPrice = price * quantity;
    return Helpers.FormatMoney(sumPrice);
  },

  moneyTotalOrderFormat: (item: any) => {
    const quantity = item.items?.length > 0 ? `${item.items?.length} loại thiết bị - ` : '';
    return quantity + Helpers.FormatMoney(Number(item.tienThanhToan));
  },

  convertOrderType(type: number) {
    switch (type) {
      case 1:
        return 'Hàng gửi';
      case 2:
        return 'Lắp mới';
      case 3:
        return 'Thu phí';
      case 4:
        return 'Sửa chữa';
      case 5:
        return 'Bảo hành';
      case 6:
        return 'Thu đổi';
      case 7:
        return 'Nâng cấp';
      case 8:
        return 'Tháo - Lắp lại';
      case 9:
        return 'ĐL lắp giùm';
      case 10:
        return 'Lắp giùm ĐL';
      case 11:
        return 'Thu nợ';
      case 12:
        return 'Trả hàng';
      case 13:
        return 'Chênh lệch';
      case 14:
        return 'Hoàn tiền';

      default:
        break;
    }
    // 'Hàng gửi',
    //       'Lắp mới',
    //       'Thu phí',
    //       'Sửa chữa',
    //       'Bảo hành',
    //       'Thu đổi',
    //       'Nâng cấp',
    //       'Tháo - Lắp lại',
    //       'ĐL lắp giùm',
    //       'Lắp giùm ĐL'
  },

  convertStatusTextToStatusClient: (currentStatus: string, operatorSeen?: boolean) => {
    switch (currentStatus) {
      case '0':
        return {
          text: '',
          statusValue: '',
          color: '#fff', // trắng màu nền..
          vnText: ''
        };
      case 'Pause': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
        return {
          text: 'OrganizedSales.OrderManager.TabName.Pause',
          statusValue: '111',
          color: '#faad14', // vàng màu nền..
          vnText: 'Tạm dừng'
        };
      case 'accountantTrue': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
        return {
          text: 'Report.FeeTracking.AccountantTrue',
          statusValue: '111',
          color: '#008000', // vàng màu nền..
          vnText: 'Đã thu tiền'
        };
      case 'accountantFalse': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
        return {
          text: 'Report.FeeTracking.AccountantFalse',
          statusValue: '112',
          color: '#db856c', // vàng màu nền..
          vnText: 'Chưa thu tiền'
        };
      case 'operateTrue': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
        return {
          text: 'Report.FeeTracking.OperateTrue',
          statusValue: '113',
          color: '#008000', // vàng màu nền..
          vnText: 'Đã thu tiền'
        };
      case 'operateFalse': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
        return {
          text: 'Report.FeeTracking.OperateFalse',
          statusValue: '114',
          color: '#db856c', // vàng màu nền..
          vnText: 'Chưa thu tiền'
        };
      case 'New': // trạng thái đơn mới và đơn mới thì cũng như là chờ ktoan xác nhận ConfirmWaitOrder
        return {
          text: 'OrganizedSales.OrderManager.TabName.WaitApproveOrder',
          statusValue: '1',
          color: '#F39C12', // vàng màu nền..
          vnText: 'Chờ duyệt'
        };
      case 'Processing': // đang thực hiện đơn (kthuat nhấn bắt đầu)
        return {
          text: 'OrganizedSales.OrderManager.TabName.InProcessOrder',
          statusValue: '2',
          color: '#006c87', //  xanh biển 0,
          vnText: 'Đang thực hiện'
        };
      case 'Pending': // đơn bị hoẵn lại do các lý do nào đó..
        return {
          text: 'OrganizedSales.OrderManager.TabName.HoldOnOrder',
          statusValue: '3',
          color: '#979797', // xám
          vnText: 'Đơn hẹn lại'
        };
      case 'Complete': // đơn thành công
        return {
          text: 'OrganizedSales.OrderManager.TabName.CompleteOrder',
          statusValue: '4',
          color: '#008000', //  xanh lá
          vnText: 'Hoàn tất'
        };
      case 'Cancel': // đơn đã huỷ
        return {
          text: 'OrganizedSales.OrderManager.TabName.CancelOrder',
          statusValue: '5',
          color: '#f50815', // đỏ đô đậm
          vnText: 'Đã huỷ'
        };
      case 'NotApproved': // đơn đã từ chối có thể là kto từ chối công nợ
        // từ chối xong là đơn này kết thúc k còn thao tác gì nữa
        return {
          text: 'OrganizedSales.OrderManager.TabName.DeclineOrder',
          statusValue: '6',
          color: '#b06f09', // vàng đậm,
          vnText: 'Từ chối'
        };

      case 'Assigned': // Đã được phân công từ điều hành xuống Kthuat
        // bắt đầu từ đây thì đơn cứ ở đã điều phối | chờ thực hiện, khi nào có kth bắt đầu thì chuyển qua
        return {
          text: 'OrganizedSales.OrderManager.TabName.Assigned',
          statusValue: '7',
          color: '#00BFFF', // xanh biển 1
          vnText: 'Chờ thực hiện'
        };

      // chưa dùng
      case '8': // đợi nhập liệu
        return {
          text: 'OrganizedSales.OrderManager.TabName.WaitEnter',
          statusValue: '8',
          color: '#0069cb' // xanh biển 2
        };

      case '9': // đợi sữa chữa
        return {
          text: 'OrganizedSales.OrderManager.TabName.WaitRepair',
          statusValue: '9',
          color: '#0069cb' // xanh biển 2
        };

      case '10': // Chờ nhận gửi
        return {
          text: 'OrganizedSales.OrderManager.TabName.ComfirmShip',
          statusValue: '10',
          color: '#db856c' // đỏ nhạt
        };

      case '11': // đơn đợi đang gửi
        return {
          text: 'OrganizedSales.OrderManager.TabName.WaitShip',
          statusValue: '11',
          color: '#6974a0' // tím nhạt
        };
      // chưa dùng
      // lưu ý khi cskh tạo đơn thì đơn này nhảy qua tới đơn hợp lệ luôn k cần qua bước ktoan
      case 'Approved': // đơn hợp lệ kto đã chấp thuận
        // bên trong này sẽ có thêm 1 trạng thái nhỏ nữa là dùng operatorSeen
        // để chuyển trạng thái Chờ điều phối thành Chờ tiếp nhận nếu  operatorSeen = false;
        // nếu operatorSeen = true thì mới đúng là chờ điều phối. về chức năng thì là như nhau
        return {
          text: 'OrganizedSales.OrderManager.TabName.Approved',
          seen: operatorSeen != undefined ? operatorSeen : true,
          statusValue: '12',
          color: '#6c0082', // chàm nhạt
          vnText: 'Chờ điều phối'
        };

      default:
        return {
          text: 'Không rõ',
          statusValue: '0',
          color: '#fff' // trắng
        };
    }
  },

  listCurrentStatus(arrayCurrentStatus?: any) {
    let arrayCurrent = '';
    for (let i = 0; i < arrayCurrentStatus.length; i++) {
      if (arrayCurrentStatus.length > 1) {
        if (arrayCurrentStatus[i].currentStatus == 'Complete' || arrayCurrentStatus[i].currentStatus == 'Cancel') {
          arrayCurrent = 'Complete';
        } else {
          return (arrayCurrent = 'Approved');
        }
      } else {
        if (arrayCurrentStatus[i].currentStatus == 'Complete' || arrayCurrentStatus[i].currentStatus == 'Cancel') {
          return (arrayCurrent = 'Complete');
        } else {
          return (arrayCurrent = 'Approved');
        }
      }
    }
    return arrayCurrent;
  },

  classificationOrder: (valueStatus?: string) => {
    if (!valueStatus) return ''; // Catch lỗi nếu valueStatus undefined

    if (ConfirmWait.includes(valueStatus)) return 'ConfirmWait';
    if (InProcess.includes(valueStatus)) return 'InProcess';
    if (Pause.includes(valueStatus)) return 'Pause';
    if (InHold.includes(valueStatus)) return 'InHold';

    // Gộp điều kiện để code ngắn hơn
    if (Success.includes(valueStatus) || Cancel.includes(valueStatus)) return 'Success';

    // Thêm điều kiện nhận diện trạng thái thu tiền
    if (valueStatus === 'Received' || valueStatus === 'Đã thu tiền') {
      // Thay chuỗi 'Received' bằng đúng value mà API trả về cho cashStatus
      return 'ConfirmPayment';
    }

    return '';
  },

  formatVarOrder: (order: IOrderManager) => {
    const statusFormat = UtilOrder.convertStatusTextToStatusClient(order.currentStatus, order.operatorSeen);
    return {
      ...order,
      branchName: order.branchInfo.name,
      status: statusFormat,
      statusVNText: statusFormat.vnText,
      uuTien: order.isPrioritized ? 'Ưu tiên' : '–',
      loaiDonHang: order.orderType.name,
      DeliverTime: new Date(order.times.thoiGianHenLap),
      CreateTime: new Date(order.times.thoiGianTao),
      CompleteTime: new Date(order.times.thoiGianHoanThanh),
      CustomerName: order.customerInfo.customerName || '–',
      tenCongTy: order.companyName === 'AnhDuong' ? 'Ánh Dương' : order.companyName === 'BinhMinh' ? 'Bình Minh' : '',
      AddressShip: order.customerInfo?.orderAddress?.address || '–',
      StaffCreate: order.staffCreate || '–',
      StaffOperate: order.staffOperate || '–',
      StaffProcesser: order.executeInfo?.map(staff => staff.staffExecute)?.join('; ') || '–',
      StaffApprove: order.staffApprove || '–',
      vatValue: order.orderVat?.vatValue || 0,
      useVAT: order.orderVat?.vatValue !== '' ? 'Có' : '–',
      totalMoney: Helpers.FormatMoney(
        order.payment.tienThanhToan ||
          ((order.orderType?.id === 4 || order.orderType?.id === 5) &&
            order.payment.tienDuKien + order.payment.chiPhiPhatSinh) ||
          0,
        true
      ), // đơn sc bh thì dùng tiền dự kiến trên server trả về khi tạo đó
      totalMoneySum:
        order.payment.tienThanhToan + order.payment.chiPhiPhatSinh ||
        ((order.orderType?.id === 4 || order.orderType?.id === 5) &&
          order.payment.tienDuKien + order.payment.chiPhiPhatSinh) ||
        0,
      payedMoney: Helpers.FormatMoney(order.payment.tienThucThu, true),
      payedMoneySum: order.payment.tienThucThu,
      vatAmount: Helpers.FormatMoney(order.payment.vatAmount, true),
      vatAmountSum: order.payment.vatAmount,
      DeviceList: null,
      DetailOrder: null,
      CSCalled: order.customerServiceCall.isCalled ? 'Đã gọi KH' : '–',
      yeuCauChinhSuaText:
        order.yeuCauChinhSua === 2 ? 'Đã cập nhật' : order.yeuCauChinhSua === 1 ? 'Chưa cập nhật' : '–',
      CusNumberPhone: order.customerInfo.customerPhone || '',
      ContactNumberPhone: order.customerInfo.sdtLienHe || '',
      DeviceListTag: 'OrganizedSales.OrderManager.AllOrder.ClickToView'
    };
  },
  formatVarCustomer: (customer: ICustomer) => {
    return {
      ...customer,
      Address: customer.address,
      PhoneList: customer.phoneList.map(phone => phone.phone).join(' ') + ' ',
      StaffSale: customer.listKinhDoanh.map(sale => sale.saleAccount).join(' ') + ' ',
      VATExport: (customer.customerVat?.vatValue || 0) + '%'
    };
  },

  formatDataOrders: (orders: IOrderManager[]) => {
    const tempArray: any[] = new Array(orders?.length);

    for (let i = 0; i < orders?.length; i++) {
      const order = orders[i];
      tempArray[i] = UtilOrder.formatVarOrder(order);
    }

    return {
      data: tempArray
    };
  },

  formatDataCustomers: (customers: ICustomer[]) => {
    const tempArray: any[] = new Array(customers?.length);

    for (let i = 0; i < customers?.length; i++) {
      const customer = customers[i];
      tempArray[i] = UtilOrder.formatVarCustomer(customer);
    }

    return {
      data: tempArray
    };
  },

  getDataOMConfig(datas, key) {
    for (let i = 0; i < datas?.data?.length; i++) {
      if (datas?.data[i].key === key) {
        return Number(datas?.data[i].data);
      }
    }
    return 0;
  },

  countOrders: (orders: IOrderManager[]) => {
    let ConfirmWaitCount = 0;
    let ConfirmPaymentCount = 0; // Đổi tên thêm chữ Count cho đồng bộ
    let InProcessCount = 0;
    let InHoldCount = 0;
    let SuccessCount = 0;
    let UnSuccesCount = 0;
    let PauseCount = 0;

    for (let i = 0; i < orders?.length; i++) {
      const order = orders[i];
      const statusTag = UtilOrder.classificationOrder(order?.currentStatus);
      const statusTagV2 = UtilOrder.classificationOrder(order?.cashStatus);

      // 1. Phân loại và đếm theo currentStatus (Trạng thái đơn hàng)
      switch (statusTag) {
        case 'ConfirmWait':
          ConfirmWaitCount += 1;
          UnSuccesCount += 1;
          break;
        case 'InProcess':
          InProcessCount += 1;
          UnSuccesCount += 1;
          break;
        case 'InHold':
          InHoldCount += 1;
          UnSuccesCount += 1;
          break;
        case 'Success':
        case 'Cancel': // Gộp chung case nếu logic của bạn quy Cancel về SuccessCount
          SuccessCount += 1;
          break;
        case 'Pause':
          PauseCount += 1;
          break;
        default:
          break;
      }

      // 2. Phân loại và đếm theo cashStatus (Trạng thái thu tiền)
      if (statusTagV2 === 'ConfirmPayment') {
        ConfirmPaymentCount += 1;
      }
    }

    return {
      ConfirmWaitCount,
      InProcessCount,
      InHoldCount,
      SuccessCount,
      PauseCount,
      ConfirmPaymentCount, // Bắt buộc phải return ra để UI tab lấy được số lượng
      AllCount: orders?.length || 0,
      UnSuccesCount
    };
  },

  formatCacLoaiDon(don: any) {
    if (
      don.type === 'Lắp mới' ||
      don.type === 'Hàng gửi' ||
      don.type === 'Thu đổi' ||
      don.type === 'ĐL lắp giùm' ||
      don.type === 'Lắp giùm ĐL'
    ) {
      if (don.item.details?.length > 0) {
        // lọc bên trong chi tiết của từng sản phẩm tương ứng
        // console.log('eeyy 2', detailsFlr);
        const detailsFlr = don.item.details.filter(
          detail =>
            (detail.maSanPham == don.item.maSanPham && detail.maBo == '') || // sản phẩm lẻ
            detail.maBo == don.item.maSanPham // thuộc bộ
        );
        if (detailsFlr.length != 0) {
          detailsFlr.forEach((itemDetail, num) => {
            if (don.num0 === 0 && num === 0) {
              const detailOrder = {
                ...don.tempData,
                ...itemDetail,
                phiGiaHan: 0,
                phiGiaHanSum: 0,
                noteDetails: itemDetail['note'],
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                tienDuKien: don.tempData.payment.tienDuKien,
                // maSanPham:
                //   itemDetail.maSanPham +
                //   ' ' +
                //   (itemDetail.tenBo?.length != 0 ? '(' + itemDetail?.tenBo + ')' : '(' + itemDetail?.tenSanPham + ')'),

                // Sửa lại hiển thị theo tên sản phẩm
                maSanPham:
                  itemDetail.tenSanPham +
                  ' ' +
                  (itemDetail.tenBo?.length != 0 ? '(' + itemDetail?.tenBo + ')' : '(' + itemDetail?.tenSanPham + ')'),
                //
                costSum: itemDetail.maBo == '' ? don.item.cost : itemDetail.serial != '' ? don.item.cost : 0,
                cost: Helpers.FormatMoney(
                  itemDetail.maBo == '' ? don.item.cost : itemDetail.serial != '' ? don.item.cost : 0,
                  true
                ),
                countOrder: 1
              };
              don.arrOrder.push(detailOrder);
            } else {
              const detailOrder = {
                ...don.tempData,
                ...itemDetail,
                phiGiaHan: 0,
                phiGiaHanSum: 0,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                tienDuKien: 0,
                noteDetails: itemDetail['note'],
                // Sửa lại hiển thị theo tên sản phẩm
                maSanPham:
                  itemDetail.tenSanPham +
                  ' ' +
                  (itemDetail.tenBo?.length != 0 ? '(' + itemDetail?.tenBo + ')' : '(' + itemDetail?.tenSanPham + ')'),
                //
                costSum: itemDetail.maBo == '' ? don.item.cost : itemDetail.serial != '' ? don.item.cost : 0,
                cost: Helpers.FormatMoney(
                  itemDetail.maBo == '' ? don.item.cost : itemDetail.serial != '' ? don.item.cost : 0,
                  true
                ),
                tienCong: 0,
                tienCongSum: 0,
                totalMoney: 0,
                totalMoneySum: 0,
                payedMoney: 0,
                payedMoneySum: 0,
                vatAmount: 0,
                vatAmountSum: 0,
                countOrder: 0
              };
              don.arrOrder.push(detailOrder);
            }
          });
        } else {
          don.arrOrder.push(
            don.num0 === 0
              ? { ...don.tempData, hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan, countOrder: 1 }
              : {
                  ...don.tempData,
                  phiGiaHan: 0,
                  phiGiahanSum: 0,
                  hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                  totalMoney: 0,
                  totalMoneySum: 0,
                  payedMoney: 0,
                  payedMoneySum: 0,
                  vatAmount: 0,
                  vatAmountSum: 0,
                  tienCong: 0,
                  tienCongSum: 0,
                  countOrder: 0
                }
          ); // chưa có chi tiết nào cho loại sp này thì add sp vô thôi
        }
      } else {
        // nếu chi tiết chưa có thì lấy cái cơ bản
        don.arrOrder.push(
          don.num0 === 0
            ? { ...don.tempData, hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan, countOrder: 1 }
            : {
                ...don.tempData,
                phiGiaHan: 0,
                phiGiahanSum: 0,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                totalMoney: 0,
                totalMoneySum: 0,
                payedMoney: 0,
                payedMoneySum: 0,
                vatAmount: 0,
                vatAmountSum: 0,
                tienCong: 0,
                tienCongSum: 0,
                countOrder: 0
              }
        );
      }
    } else if (don.type === 'Thu phí') {
      if (don.item.details.length > 0) {
        don.item.details.forEach((itemDetail, index) => {
          if (index === 0) {
            const detailOrder = {
              ...don.tempData,
              ...itemDetail,
              hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
              tienDuKien: don.tempData.payment.tienDuKien,
              noteDetails: itemDetail['note'],
              // costSum: itemDetail['cost'],
              // cost: Helpers.FormatMoney(itemDetail['cost'], true),
              cost: 0,
              costSum: 0,
              phiGiaHanSum: itemDetail['cost'],
              phiGiaHan: Helpers.FormatMoney(itemDetail['cost'], true),
              registrationPlate: itemDetail['bs'],
              countOrder: 1
            };
            don.arrOrder.push(detailOrder);
          } else {
            const detailOrder = {
              ...don.tempData,
              ...itemDetail,
              hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
              tienDuKien: 0,
              noteDetails: itemDetail['note'],
              // costSum: itemDetail['cost'],
              // cost: Helpers.FormatMoney(itemDetail['cost'], true),
              cost: 0,
              costSum: 0,
              phiGiaHanSum: itemDetail['cost'],
              phiGiaHan: Helpers.FormatMoney(itemDetail['cost'], true),
              registrationPlate: itemDetail['bs'],
              totalMoney: 0,
              totalMoneySum: 0,
              payedMoney: 0,
              payedMoneySum: 0,
              vatAmount: 0,
              vatAmountSum: 0,
              tienCong: 0,
              tienCongSum: 0,
              countOrder: 0
            };
            don.arrOrder.push(detailOrder);
          }
        });
      } else {
        // nếu chi tiết chưa có thì lấy cái cơ bản
        don.arrOrder.push(
          don.num0 === 0
            ? {
                ...don.tempData,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                countOrder: 1
              }
            : {
                ...don.tempData,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                totalMoney: 0,
                totalMoneySum: 0,
                payedMoney: 0,
                payedMoneySum: 0,
                vatAmount: 0,
                vatAmountSum: 0,
                tienCong: 0,
                tienCongSum: 0,
                countOrder: 0
              }
        );
      }
    } else if (don.type === 'Sửa chữa' || don.type === 'Bảo hành') {
      if (don.item.details.length > 0) {
        don.item.details.forEach((itemDetail, index) => {
          // console.log('itemDetail',  don.tempData);
          if (index === 0) {
            const detailOrder = {
              ...don.tempData,
              ...itemDetail,
              hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
              tienDuKien: don.tempData.payment.tienDuKien,
              noteDetails: itemDetail['note'],
              note: don.tempData.note,
              costSum: itemDetail['cost'],
              cost: Helpers.FormatMoney(itemDetail['cost'], true),
              phiGiaHan: 0,
              phiGiaHanSum: 0,
              maSanPham: itemDetail['newMaSanPham'],
              serial: itemDetail['newSerial'],
              countOrder: 1
            };
            don.arrOrder.push(detailOrder);
          } else {
            const detailOrder = {
              ...don.tempData,
              ...itemDetail,
              hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
              tienDuKien: 0,
              phiGiaHan: 0,
              phiGiaHanSum: 0,
              noteDetails: itemDetail['note'],
              costSum: itemDetail['cost'],
              cost: Helpers.FormatMoney(itemDetail['cost'], true),
              maSanPham: itemDetail['newMaSanPham'],
              serial: itemDetail['newSerial'],
              totalMoney: 0,
              totalMoneySum: 0,
              payedMoney: 0,
              payedMoneySum: 0,
              vatAmount: 0,
              vatAmountSum: 0,
              tienCong: 0,
              tienCongSum: 0,
              countOrder: 0
            };
            don.arrOrder.push(detailOrder);
          }
        });
      } else {
        // nếu chi tiết chưa có thì lấy cái cơ bản
        don.arrOrder.push(
          don.num0 === 0
            ? {
                ...don.tempData,
                phiGiaHan: 0,
                phiGiaHanSum: 0,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                countOrder: 1
              }
            : {
                ...don.tempData,
                phiGiaHan: 0,
                phiGiaHanSum: 0,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                totalMoney: 0,
                totalMoneySum: 0,
                payedMoney: 0,
                payedMoneySum: 0,
                vatAmount: 0,
                vatAmountSum: 0,
                tienCong: 0,
                tienCongSum: 0,
                countOrder: 0
              }
        );
      }
    } else if (don.type === 'Nâng cấp') {
      if (don.item.details.length > 0) {
        don.item.details.forEach((itemDetail, index) => {
          if (index === 0) {
            const detailOrder = {
              ...don.tempData,
              ...itemDetail,
              phiGiaHan: 0,
              phiGiaHanSum: 0,
              hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
              tienDuKien: don.tempData.payment.tienDuKien,
              noteDetails: itemDetail['note'],
              costSum: itemDetail.cost,
              cost: Helpers.FormatMoney(itemDetail.cost, true),
              maSanPham: itemDetail.maSanPhamMoi,
              oldMaSanPham: itemDetail.maSanPhamCu,
              countOrder: 1
            };
            don.arrOrder.push(detailOrder);
          } else {
            const detailOrder = {
              ...don.tempData,
              ...itemDetail,
              hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
              tienDuKien: 0,
              noteDetails: itemDetail['note'],
              costSum: itemDetail.cost,
              cost: Helpers.FormatMoney(itemDetail.cost, true),
              phiGiaHan: 0,
              phiGiaHanSum: 0,
              maSanPham: itemDetail.maSanPhamMoi,
              oldMaSanPham: itemDetail.maSanPhamCu,
              totalMoney: 0,
              totalMoneySum: 0,
              payedMoney: 0,
              payedMoneySum: 0,
              vatAmount: 0,
              vatAmountSum: 0,
              tienCong: 0,
              tienCongSum: 0,
              countOrder: 0
            };
            don.arrOrder.push(detailOrder);
          }
        });
      } else {
        // nếu chi tiết chưa có thì lấy cái cơ bản
        don.arrOrder.push(
          don.num0 === 0
            ? {
                ...don.tempData,
                phiGiaHan: 0,
                phiGiaHanSum: 0,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                countOrder: 1
              }
            : {
                ...don.tempData,
                phiGiaHan: 0,
                phiGiaHanSum: 0,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                totalMoney: 0,
                totalMoneySum: 0,
                payedMoney: 0,
                payedMoneySum: 0,
                vatAmount: 0,
                vatAmountSum: 0,
                tienCong: 0,
                tienCongSum: 0,
                countOrder: 0
              }
        );
      }
    } else if (don.type === 'Tháo - Lắp lại') {
      // console.log('thao lap lai', don.tempData,don.item);
      if (don.item.details?.length > 0) {
        don.item.details.forEach((itemDetail, index) => {
          if (index === 0) {
            const detailOrder = {
              ...don.tempData,
              ...itemDetail,
              phiGiaHan: 0,
              phiGiaHanSum: 0,
              hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
              tienDuKien: don.tempData.payment.tienDuKien,
              noteDetails: itemDetail['note'],
              costSum: itemDetail.cost,
              cost: Helpers.FormatMoney(itemDetail.cost, true),
              companyId: itemDetail.newCompanyId,
              // oldMaSanPham
              // oldSerial
              maSanPham: itemDetail.maSanPham,
              registrationPlate: itemDetail['newRegistrationPlate'],
              serial: itemDetail['serial'],
              countOrder: 1
              // DeviceList:item.
            };
            don.arrOrder.push(detailOrder);
          } else {
            const detailOrder = {
              ...don.tempData,
              ...itemDetail,
              hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
              tienDuKien: 0,
              noteDetails: itemDetail['note'],
              costSum: itemDetail.cost,
              phiGiaHan: 0,
              phiGiaHanSum: 0,
              cost: Helpers.FormatMoney(itemDetail.cost, true),
              companyId: itemDetail.newCompanyId,
              maSanPham: itemDetail.maSanPham,
              registrationPlate: itemDetail['newRegistrationPlate'],
              serial: itemDetail['serial'],
              totalMoney: 0,
              totalMoneySum: 0,
              payedMoney: 0,
              payedMoneySum: 0,
              vatAmount: 0,
              vatAmountSum: 0,
              tienCong: 0,
              tienCongSum: 0,
              countOrder: 0
            };
            don.arrOrder.push(detailOrder);
          }
        });
      } else {
        // nếu chi tiết chưa có thì lấy cái cơ bản
        don.arrOrder.push(
          don.num0 === 0
            ? {
                ...don.tempData,
                phiGiaHan: 0,
                phiGiaHanSum: 0,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                countOrder: 1
              }
            : {
                ...don.tempData,
                phiGiaHan: 0,
                phiGiaHanSum: 0,
                hinhThucThanhToan: don.tempData.payment.hinhThucThanhToan,
                totalMoney: 0,
                totalMoneySum: 0,
                payedMoney: 0,
                payedMoneySum: 0,
                vatAmount: 0,
                vatAmountSum: 0,
                tienCong: 0,
                tienCongSum: 0,
                countOrder: 0
              }
        );
      }
    }
    return don.arrOrder;
  },

  formatOneDataOrder: (order: IOrderManager | null | undefined, isReport?: boolean) => {
    // console.log(' formatOne', order);
    if (!order) {
      return null;
    }
    // cần qua 1 bước xử lý nữa
    const tempOrder: any = UtilOrder.formatVarOrder(order);
    if (
      order.orderType?.id === 1 ||
      order.orderType?.id === 2 ||
      order.orderType?.id === 6 ||
      order.orderType?.id === 9 ||
      order.orderType?.id === 10
    ) {
      // xử lý phần chi tiết các sản phẩm trong đơn cơ bản
      let quantityProduct = 0;
      tempOrder['items'] =
        order.itemSummaries?.map(item => {
          quantityProduct += item.quantity;
          return {
            ...item,
            cost: item.cost
            // details: order.itemDetails // tạm không cần dùng đến dạng sub con này
          };
        }) || [];
      tempOrder['totalProductMix'] = order.itemSummaries?.length;
      tempOrder['totalProduct'] = quantityProduct;
      tempOrder['DeviceList'] =
        order.itemSummaries?.length !== 0
          ? order.itemSummaries?.map(item => (item.tenSanPham ? item.tenSanPham + '; ' : item.maSanPham + '; '))
          : [];
      tempOrder['isDetailLoaded'] = true;
      // ghi rõ loại đơn, và các serial có liên quan...
      tempOrder['DetailOrder'] = `${
        '(' + quantityProduct + ' SP / ' + tempOrder['totalProductMix'] + ' loại) ' + tempOrder['DeviceList']?.join('')
      }`;

      // xử lý gom đơn theo bs số cũ => biển số mới
      // sắp xếp và tiến hành xử lý định dạng và gom dữ liệu lại kèm theo key là BS
      const tempDetail = [...order.itemDetails].map((item: any, index: number) => ({
        Bs: item.registrationPlate,
        child: {
          ...item
        }
      }));

      // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
      // lưu ý là phải đúng với format bên form update
      const mergeList = new Map(tempDetail.map(({ Bs, child }) => [Bs, { Bs, child: [] }]));
      for (const { Bs, child } of tempDetail) mergeList.get(Bs)?.child.push(...[child].flat());
      // console.log('mergeList', [...mergeList.values()]);
      //
      const tempList: any = [];

      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        let obj = {
          ...[...mergeList.values()][i]
        };
        if ([...mergeList.values()][i].child?.length != 0) {
          const objDetail: any = [];
          obj = {
            ...[...mergeList.values()][i].child[0]
          };

          for (let j = 0; j < [...mergeList.values()][i].child.length; j++) {
            objDetail.push({
              id: [...mergeList.values()][i].child[j]['id'] || 0,
              maSanPham: [...mergeList.values()][i].child[j]['maSanPham'] || '',
              serial: [...mergeList.values()][i].child[j]['serial'] || '',
              phone: [...mergeList.values()][i].child[j]['phone'] || '',
              staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',
              maBo: [...mergeList.values()][i].child[j]['maBo'] || ''
            });
          }

          obj['details'] = objDetail || [];
          tempList.push(obj);
        }
      }
      // console.log('tempOrder', tempOrder);
      tempOrder['itemDetailsMerg'] = tempList || [];

      if (isReport) {
        // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
        tempOrder['thoiGianDieuDon'] =
          order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
            ?.updateTime === undefined
            ? ''
            : new Date(
                order?.statusDetails?.find(
                  staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
                )?.updateTime
              );
        tempOrder['itemsReport'] =
          order.itemSummaries
            ?.map(item => {
              quantityProduct += item.quantity;
              return {
                ...item,
                cost: item.cost,
                details: order.itemDetails.sort((a, b) => (a.serial.length != 0 ? -1 : 1)) // chi tiết các xe
              };
            })
            .sort((a, b) => (a.tenSanPham.startsWith('Bộ') ? -1 : 1)) || [];
        tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
        tempOrder['StaffCancel'] = order.staffCancel || '';
        tempOrder['StaffProcesser'] = order.staffComplete || '';
      }
    }

    if (order.orderType?.id === 12) {
      const details = order.itemDetails || [];

      // 1. Gom nhóm Plate và xử lý logic gộp không Serial/Phone
      const groupedByPlate = details.reduce((acc, item) => {
        const plate = item.registrationPlate;
        if (!acc[plate]) {
          acc[plate] = { ...item, details: [] };
        }

        const serial = item.serial || '';
        const phone = item.phone || '';
        const isGeneric = serial === '' && phone === '';

        // Tìm xem trong Plate này đã có dòng "không định danh" cùng loại chưa
        const existingInPlate = isGeneric
          ? acc[plate].details.find(d => d.maSanPham === item.maSanPham && d.serial === '' && d.phone === '')
          : null;

        if (existingInPlate) {
          existingInPlate.quantity += 1;
        } else {
          acc[plate].details.push({
            ...item,
            quantity: 1,
            cost: item.cost || 0
          });
        }
        return acc;
      }, {});

      const mergedDetails = Object.values(groupedByPlate);
      tempOrder['itemDetailsMerg'] = mergedDetails;

      // 2. Tạo danh sách "Summary" từ Details (Vì không dùng itemSummaries)
      // Gom tất cả sản phẩm lại để tính tổng Qty và DeviceList
      const summaryFromDetails = details.reduce((acc, item) => {
        const key = item.maSanPham;
        if (!acc[key]) {
          acc[key] = {
            maSanPham: item.maSanPham,
            tenSanPham: item.tenSanPham || item.maSanPham,
            quantity: 0,
            cost: item.cost || 0
          };
        }
        acc[key].quantity += 1;
        return acc;
      }, {});

      const finalSummaries = Object.values(summaryFromDetails);
      const totalQty = details.length;

      tempOrder['items'] = finalSummaries;
      tempOrder['totalProductMix'] = finalSummaries.length;
      tempOrder['totalProduct'] = totalQty;
      tempOrder['isDetailLoaded'] = true;

      // 3. Xử lý chuỗi hiển thị
      const deviceNames = finalSummaries.map(item => `${item.tenSanPham} (${item.quantity}); `);
      tempOrder['DeviceList'] = deviceNames;
      tempOrder['DetailOrder'] = `(${totalQty} SP / ${finalSummaries.length} loại) ${deviceNames.join('')}`;

      // 4. Xử lý dữ liệu Báo cáo (isReport)
      if (isReport) {
        const assignStatus = order.statusDetails?.find(s => s.staffBehavior === 'Assign' && s.status === 'Assigned');
        tempOrder['thoiGianDieuDon'] = assignStatus?.updateTime ? new Date(assignStatus.updateTime) : '';
        tempOrder['itemsReport'] = finalSummaries
          .map(s => ({
            ...s,
            // Lấy chi tiết của từng loại sản phẩm từ mảng đã gộp ở trên
            details: mergedDetails
              .flatMap(p => p.details)
              .filter(d => d.maSanPham === s.maSanPham)
              .sort((a, b) => (b.serial?.length || 0) - (a.serial?.length || 0))
          }))
          .sort((a, b) => (a.tenSanPham?.startsWith('Bộ') ? -1 : 1));

        tempOrder['companyNameEx'] = COMPANY_NAMES.find(c => c.value === order.companyName)?.label || '';
        tempOrder['StaffCancel'] = order.staffCancel || '';
        tempOrder['StaffProcesser'] = order.staffComplete || '';
      }
    }

    // if (order.orderType?.id === 11) {
    //   // 1️ Helper chuẩn hóa biển số / serial (phân cách ;)
    //   const formatStringToDisplay = (val: any) => {
    //     if (!val) return '';
    //     return String(val).replace(/;/g, ', ');
    //   };
    //   console.log({ order });

    //   // 2️ Map danh sách đơn nợ mới
    //   const inDebtOrderCodes = (order.danhSachDonNo || []).map(item => ({
    //     maDonHang: item.maDonHang || '',
    //     bienSoXe: formatStringToDisplay(item.bienSoXe),
    //     serial: formatStringToDisplay(item.serial),

    //     // Tiền còn nợ (vì chưa có tiềnThucThu nên lấy trực tiếp tienNo)
    //     tongTienDonNo: Number(item.tienNo || 0),
    //     tienNo: Number(item.tienNo || 0),

    //     originalTotal: Number(item.tienNo || 0),

    //     staffCreate: item.nguoiTao || '',
    //     checked: true, // mặc định chọn
    //     soHoaDon: order.soHoaDon || '',
    //     orderType: item.loai || '',

    //     goiCuoc: Number(item.goiCuoc || 0),
    //     type: item.type ?? 1
    //   }));

    //   // 3️ Chuẩn hóa list kinh doanh
    //   const listKinhDoanh = Array.isArray(order.listKinhDoanh)
    //     ? order.listKinhDoanh.length > 0
    //       ? order.listKinhDoanh
    //       : ['']
    //     : order.listKinhDoanh
    //     ? [order.listKinhDoanh]
    //     : [''];

    //   // 4️ Group lại cho Form.List
    //   const thuNoGroup = {
    //     listKinhDoanh: listKinhDoanh,
    //     inDebtOrderCodes: inDebtOrderCodes,
    //     soHoaDon: order.soHoaDon || ''
    //   };

    //   // 5️ Gán vào tempOrder
    //   tempOrder['ThuNoItems'] = [thuNoGroup];
    // }

    if (order.orderType?.id === 11) {
      const formatStringToDisplay = (val: any) => {
        if (!val) return '';
        return String(val).replace(/;/g, ', ');
      };

      // 2️ Xử lý gộp dữ liệu (Grouping) từ Server trả về
      const groupedDebtOrders = (order.danhSachDonNo || []).reduce((acc: any[], item: any) => {
        // Tìm nhóm "Hóa Đơn" trùng mã đơn hàng
        const existingGroup = acc.find(g => g.maDonHang === item.maDonHang && item.loai === 'Hóa đơn');

        const processedItem = {
          maDonHang: item.maDonHang || '',
          bienSoXe: formatStringToDisplay(item.bienSoXe),
          serial: formatStringToDisplay(item.serial),
          tongTienDonNo: Number(item.tienNo || 0),
          tienNo: Number(item.tienNo || 0),
          originalTotal: Number(item.tienNo || 0),
          // Map đúng tên field "nguoiTao" và "ngay" như trong Form.List của component
          nguoiTao: item.nguoiTao || '',
          ngay: item.ngayHoanThanh || item.ngay ? moment(item.ngayHoanThanh || item.ngay).format('DD/MM/YYYY') : '-',
          checked: true,
          orderType: item.loai || '',
          goiCuoc: Number(item.goiCuoc || 0),
          thuVat: Number(item.thuVat || 0),
          thuGoiCuoc: Number(item.thuGoiCuoc) || 0,
          thuChenhLech: Number(item.thuChenhLech || 0),
          type: item.type ?? 1,
          id: item.id
        };

        if (item.loai === 'Hóa đơn') {
          // Tìm nhóm đã tồn tại dựa trên mã đơn hàng
          const existingGroup = acc.find(g => g.maDonHang === item.maDonHang && g.orderType === 'Hóa đơn');

          if (!existingGroup) {
            // Khởi tạo nhóm mới
            acc.push({
              ...processedItem,
              isGroup: true,
              childItems: [{ ...processedItem }] // Khởi tạo mảng con
            });
          } else {
            // 1. Cộng dồn giá trị số
            existingGroup.tienNo += processedItem.tienNo;
            existingGroup.tongTienDonNo += processedItem.tongTienDonNo;
            existingGroup.goiCuoc += processedItem.goiCuoc;
            existingGroup.thuVat += processedItem.thuVat;
            existingGroup.thuChenhLech += processedItem.thuChenhLech;

            // 2. Gộp chuỗi (Biển số & Serial) - Dùng hàm helper cho sạch code
            const mergeStrings = (oldStr: string, newStr: string) => {
              const combined = [...(oldStr?.split(', ') || []), ...(newStr?.split(', ') || [])];
              return Array.from(new Set(combined)).filter(Boolean).join(', ');
            };

            existingGroup.bienSoXe = mergeStrings(existingGroup.bienSoXe, processedItem.bienSoXe);
            existingGroup.serial = mergeStrings(existingGroup.serial, processedItem.serial);

            // 3. QUAN TRỌNG: Push vào mảng con (Bỏ comment và thêm check an toàn)
            if (!existingGroup.childItems) existingGroup.childItems = [];
            existingGroup.childItems.push(processedItem);
          }
        } else {
          // Không phải Hóa đơn thì thêm mới như một dòng độc lập
          acc.push({ ...processedItem, isGroup: false, childItems: [] });
        }
        return acc;
      }, []);

      // 3️ Chuẩn hóa list kinh doanh (Xử lý mảng rỗng để tránh lỗi [""])
      const listKinhDoanh = Array.isArray(order.listKinhDoanh)
        ? order.listKinhDoanh.length > 0
          ? order.listKinhDoanh
          : ['']
        : order.listKinhDoanh
        ? [order.listKinhDoanh]
        : [''];

      // 4️ Gán vào ThuNoItems
      tempOrder['ThuNoItems'] = [
        {
          listKinhDoanh: listKinhDoanh,
          inDebtOrderCodes: groupedDebtOrders,
          soHoaDon: order.soHoaDon || ''
        }
      ];
    }

    if (order.orderType?.id === 13) {
      // 1. Đảm bảo dữ liệu luôn là mảng để tránh lỗi
      const listKDArray = Array.isArray(order.listKinhDoanh) ? order.listKinhDoanh : [];
      const diffArray = Array.isArray(order.diff) ? order.diff : [];

      // 2. Tạo mảng chứa 1 object duy nhất gộp cả 2 thông tin
      const tempList = [
        {
          listKinhDoanh: listKDArray,
          diff: diffArray
        }
      ];

      // 3. Gán vào object tổng
      tempOrder['ChenhLechItems'] = tempList;
    }

    if (order.orderType?.id === 3) {
      const tempDetail = [...order.collectingFeeInfo.detail].map((item: any, index: number) => ({
        Bs: item.bs,
        child: {
          ...item
        }
      }));
      // chỗ này cần tách theo mã cũ => mã mới + Bs theo // gộp theo BS như này là chưa đủ! => có trường hợp 1 xe nâng cấp nhiều thứ
      // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
      // lưu ý là phải đúng với format bên form update
      const mergeList = new Map(tempDetail.map(({ Bs, child }) => [Bs, { Bs, child: [] }]));
      for (const { Bs, child } of tempDetail) mergeList.get(Bs)?.child.push(...[child].flat());
      console.log('mergeList', [...mergeList.values()]);
      //
      const tempList: any = [];

      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        let obj = {};
        // kiểm tra coi nếu như có mã sản phẩm cũ thì mã cũ này add nó vào list tổng sản phẩm
        if ([...mergeList.values()][i].child?.length != 0) {
          const objDetail: any = [];
          // ẩn này vì bên ngoài có rồi
          for (let j = 0; j < [...mergeList.values()][i].child?.length; j++) {
            if ([...mergeList.values()][i].child[j]['type'] == 0) {
              obj = { ...[...mergeList.values()][i].child[j] };
            } else {
              objDetail.push({
                id: [...mergeList.values()][i].child[j]['id'] || 0,
                maSanPham: [...mergeList.values()][i].child[j]['maSanPham'] || '',
                serial: [...mergeList.values()][i].child[j]['serial'] || '',
                phone: [...mergeList.values()][i].child[j]['phone'] || '',
                cost: [...mergeList.values()][i].child[j]['cost'] || 0,
                old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
                // maBo: [...mergeList.values()][i].child[j]['maBo'] || ''
              });
            }
          }

          obj['details'] = objDetail || [];
          // obj['products'] = objProduct || [];
          tempList.push(obj);
        }

        tempOrder['payFees'] = tempList;
      }

      // chi tiết sp trong đơn thu phí
      tempOrder['tienCongSum'] = order.payment.chiPhiPhatSinh + order.payment.tienDuKien;
      tempOrder['tienCong'] = Helpers.FormatMoney(order.payment.chiPhiPhatSinh + order.payment.tienDuKien, true);
      tempOrder['thoiGianDongPhi'] = order.collectingFeeInfo.thoiGianDongPhi;
      tempOrder['thoiGianHetHan'] = order.collectingFeeInfo.thoiGianHetHan;
      tempOrder['month'] = order.collectingFeeInfo.month;
      // tempOrder['payFees'] = order.collectingFeeInfo.detail;
      tempOrder['CompanyName'] = order.collectingFeeInfo.companyName;
      tempOrder['DeviceList'] = order.collectingFeeInfo.detail || [];
      tempOrder['DetailOrder'] = `${'T.Phí ' + (tempOrder['DeviceList']?.length || 0) + ' xe'}`;
      tempOrder['isDetailLoaded'] = true;
      if (isReport) {
        // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
        tempOrder['thoiGianDieuDon'] =
          order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
            ?.updateTime === undefined
            ? ''
            : new Date(
                order?.statusDetails?.find(
                  staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
                )?.updateTime
              );
        tempOrder['itemsReport'] = [{ details: order.collectingFeeInfo.detail }];
        tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
        tempOrder['StaffCancel'] = order.staffCancel || '';
        tempOrder['StaffProcesser'] = order.staffComplete || '';
      }
    }
    if (order.orderType?.id === 4 || order.orderType?.id === 5) {
      // chi tiết sp trong đơn sửa chữa bảo hành
      // warranty
      // repairingInfo
      tempOrder['tienCongSum'] = order.payment.chiPhiPhatSinh + order.payment.tienDuKien;
      tempOrder['tienCong'] = Helpers.FormatMoney(order.payment.chiPhiPhatSinh + order.payment.tienDuKien, true);

      tempOrder['warranty'] = order.warranty;
      tempOrder['errorList'] = order.repairingInfo.map(error => ({
        ...error,
        cost: error.cost
      }));
      tempOrder['DeviceList'] = true;
      tempOrder['DetailOrder'] = `${'S.Chữa | B.Hành ' + (order.repairingInfo?.length || 0) + ' bộ'}`;
      tempOrder['isDetailLoaded'] = true;

      // let quantityDevice = 0;
      // không cn dùng nên tạm ẩn để đây
      // tempOrder['upgrades'] =
      //   order.upgradeSummaries?.map(item => {
      //     const listDetail = order.upgradeDetails.filter(
      //       itemDF => itemDF.maSanPhamCu === item.maSanPhamCu && itemDF.maSanPhamMoi === item.maSanPhamMoi
      //     );
      //     quantityDevice += item.quantity;
      //     return {
      //       ...item,
      //       details: listDetail
      //     };
      //   }) || [];
      // khởi tạo hàm gom nhóm sản phẩm theo bs đôi với đơn nâg cấp này
      // xử lý gom đơn theo bs số cũ => biển số mới
      // sắp xếp và tiến hành xử lý định dạng và gom dữ liệu lại kèm theo key là BS
      const tempDetail = [...order.repairingInfo].map((item: any, index: number) => ({
        Bs: item.registrationPlate + item.phenomenon + item.errorTpye,
        //  + item.phenomenon + item.diagnosis + item.errorTpye,
        child: {
          ...item
        }
      }));
      // chỗ này cần tách theo mã cũ => mã mới + Bs theo // gộp theo BS như này là chưa đủ! => có trường hợp 1 xe nâng cấp nhiều thứ
      // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
      // lưu ý là phải đúng với format bên form update
      const mergeList = new Map(tempDetail.map(({ Bs, child }) => [Bs, { Bs, child: [] }]));
      for (const { Bs, child } of tempDetail) mergeList.get(Bs)?.child.push(...[child].flat());
      // console.log('  mergeList', [...mergeList.values()]);
      //
      const tempList: any = [];

      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        const obj = { ...[...mergeList.values()][i].child[0] };
        // kiểm tra coi nếu như có mã sản phẩm cũ thì mã cũ này add nó vào list tổng sản phẩm
        if ([...mergeList.values()][i].child?.length != 0) {
          const objDetail: any = [];
          const objError: any = [];

          // ẩn này vì bên ngoài có rồi
          for (let j = 0; j < [...mergeList.values()][i].child?.length; j++) {
            const rawDiagnosis = [...mergeList.values()][i].child[j]['diagnosis'];
            const rawHandling = [...mergeList.values()][i].child[j]['handling'];

            const newDiagnosis = rawDiagnosis ? rawDiagnosis.split(';') : [];
            const newHandling = rawHandling ? rawHandling.split(';') : [];

            const mapDiagnosis = {};

            for (let k = 0; k < newDiagnosis.length; k++) {
              const diag = newDiagnosis[k]?.trim();
              const hand = newHandling[k]?.trim();

              if (!diag) continue;

              if (!mapDiagnosis[diag]) {
                mapDiagnosis[diag] = [];
              }

              if (hand && !mapDiagnosis[diag].includes(hand)) {
                mapDiagnosis[diag].push(hand);
              }
            }
            for (const diag of Object.keys(mapDiagnosis)) {
              const existing = objError.find(item => item.newDiagnosis === diag);

              if (existing) {
                // Gộp thêm handling nếu chưa có
                for (const h of mapDiagnosis[diag]) {
                  if (!existing.newHandling.includes(h)) {
                    existing.newHandling.push(h);
                  }
                }
              } else {
                // Chưa có thì push mới
                objError.push({
                  newDiagnosis: diag,
                  newHandling: [...mapDiagnosis[diag]] // dùng spread để tránh tham chiếu
                });
              }
            }
            // console.log('merlist', [...mergeList.values()][i].child[j]);

            if (!([...mergeList.values()][i].child[j]['newMaSanPham'] == '')) {
              // && tempOrder.status.statusValue == '4'
              // hoàn tất thì bỏ đi những cái có newMaSanPham là string rỗng
              objDetail.push({
                id: [...mergeList.values()][i].child[j]['id'] || 0,
                newMaSanPham: [...mergeList.values()][i].child[j]['newMaSanPham'] || '',
                newSerial: [...mergeList.values()][i].child[j]['newSerial'] || '',
                newPhone: [...mergeList.values()][i].child[j]['newPhone'] || '',
                staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',
                staffCreate: [...mergeList.values()][i].child[j]['staffCreate'] || '',
                cost: [...mergeList.values()][i].child[j]['cost'] || 0,
                note: [...mergeList.values()][i].child[j]['note'] || '',
                old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
                // maBo: [...mergeList.values()][i].child[j]['maBo'] || ''
              });
            }
          }
          obj['details'] = objDetail || [];
          obj['errors'] = objError || [];
          // obj['products'] = objProduct || [];
          tempList.push(obj);
        }
        tempOrder['itemsRepair'] = tempList;
      }
      if (isReport) {
        // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
        tempOrder['thoiGianDieuDon'] =
          order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
            ?.updateTime === undefined
            ? ''
            : new Date(
                order?.statusDetails?.find(
                  staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
                )?.updateTime
              );
        tempOrder['itemsReport'] = [{ details: order.repairingInfo }];
        tempOrder['StaffCancel'] = order.staffCancel || '';
        tempOrder['StaffProcesser'] = order.staffComplete || '';
        tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
      }
      console.log('tempOrder', tempOrder);
    }
    if (order.orderType?.id === 7) {
      // chi tiết sp trong đơn nâng cấp
      // upgradeSummaries
      // upgradeDetails
      // upgrades

      tempOrder['tienCong'] = Helpers.FormatMoney(order.payment.chiPhiPhatSinh + order.payment.tienDuKien, true);
      tempOrder['tienCongSum'] = order.payment.chiPhiPhatSinh + order.payment.tienDuKien;

      tempOrder['upgradeSummaries'] = order.upgradeSummaries;
      tempOrder['upgradeDetails'] = order.upgradeDetails;
      // tempOrder['upgradeProducts'] = order.upgradeProducts;
      tempOrder['isDetailLoaded'] = true;
      let quantityDevice = 0;
      // không cn dùng nên tạm ẩn để đây
      // tempOrder['upgrades'] =
      //   order.upgradeSummaries?.map(item => {
      //     const listDetail = order.upgradeDetails.filter(
      //       itemDF => itemDF.maSanPhamCu === item.maSanPhamCu && itemDF.maSanPhamMoi === item.maSanPhamMoi
      //     );
      //     quantityDevice += item.quantity;
      //     return {
      //       ...item,
      //       details: listDetail
      //     };
      //   }) || [];
      // khởi tạo hàm gom nhóm sản phẩm theo bs đôi với đơn nâg cấp này
      // xử lý gom đơn theo bs số cũ => biển số mới
      // sắp xếp và tiến hành xử lý định dạng và gom dữ liệu lại kèm theo key là BS
      const tempDetail = [...order.upgradeDetails].map((item: any, index: number) => ({
        Bs: item.registrationPlate,
        child: {
          ...item
        }
      }));
      // chỗ này cần tách theo mã cũ => mã mới + Bs theo // gộp theo BS như này là chưa đủ! => có trường hợp 1 xe nâng cấp nhiều thứ
      // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
      // lưu ý là phải đúng với format bên form update
      const mergeList = new Map(tempDetail.map(({ Bs, child }) => [Bs, { Bs, child: [] }]));
      for (const { Bs, child } of tempDetail) mergeList.get(Bs)?.child.push(...[child].flat());
      // console.log('mergeList', [...mergeList.values()]);
      //
      const tempList: any = [];

      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        const obj = { ...[...mergeList.values()][i].child[0] };
        // kiểm tra coi nếu như có mã sản phẩm cũ thì mã cũ này add nó vào list tổng sản phẩm
        if ([...mergeList.values()][i].child?.length != 0) {
          const objDetail: any = [];
          const objProduct: any = [];
          // ẩn này vì bên ngoài có rồi
          for (let j = 0; j < [...mergeList.values()][i].child?.length; j++) {
            // bước bỏ đi các sản phẩm k có mã cũ => đây là các sản phâm phụ thêm vào cho xe này
            if (
              ![...mergeList.values()][i].child[j]['maSanPhamCu'] ||
              [...mergeList.values()][i].child[j]['maSanPhamCu']?.length == 0
            )
              objDetail.push({
                id: [...mergeList.values()][i].child[j]['id'] || 0,
                maSanPham: [...mergeList.values()][i].child[j]['maSanPhamMoi'] || '',
                serial: [...mergeList.values()][i].child[j]['serial'] || '',
                phone: [...mergeList.values()][i].child[j]['phone'] || '',
                staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',
                staffCreate: [...mergeList.values()][i].child[j]['staffCreate'] || '',
                cost: [...mergeList.values()][i].child[j]['cost'] || 0,
                old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
                // maBo: [...mergeList.values()][i].child[j]['maBo'] || ''
              });
            else {
              objProduct.push({
                id: [...mergeList.values()][i].child[j]['id'] || 0,
                maSanPhamCu: [...mergeList.values()][i].child[j]['maSanPhamCu'] || '',
                maSanPhamMoi: [...mergeList.values()][i].child[j]['maSanPhamMoi'] || '',
                preMaSanPham: [...mergeList.values()][i].child[j]['maSanPhamMoi'] || '',
                serial: [...mergeList.values()][i].child[j]['serial'] || '',
                phone: [...mergeList.values()][i].child[j]['phone'] || '',
                serialCu: [...mergeList.values()][i].child[j]['serialCu'] || '',
                phoneCu: [...mergeList.values()][i].child[j]['phoneCu'] || '',
                staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',
                staffCreate: [...mergeList.values()][i].child[j]['staffCreate'] || '',
                cost: [...mergeList.values()][i].child[j]['cost'] || 0,
                old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
              });

              quantityDevice += 1;
            }
          }

          obj['details'] = objDetail || [];
          obj['products'] = objProduct || [];
          tempList.push(obj);
        }
      }
      tempOrder['DeviceList'] = true;
      tempOrder['totalUpgrade'] = quantityDevice;
      tempOrder['DetailOrder'] = `${
        'N.Cấp ' + (quantityDevice || 0) + ' xe' + ' ' + order.upgradeDetails?.length + ' SP'
      }`;

      // console.log('tempList', tempList);
      tempOrder['itemUpgradesMerg'] = tempList;

      if (isReport) {
        tempOrder['thoiGianDieuDon'] =
          order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
            ?.updateTime === undefined
            ? ''
            : new Date(
                order?.statusDetails?.find(
                  staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
                )?.updateTime
              );
        // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
        tempOrder['itemsReport'] = [{ details: order.upgradeDetails }];
        tempOrder['StaffCancel'] = order.staffCancel || '';
        tempOrder['StaffProcesser'] = order.staffComplete || '';
        tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
      }
    }

    if (order.orderType?.id === 8) {
      // chi tiết sp trong đơn tháo
      tempOrder['isDetailLoaded'] = true;
      tempOrder['tienCongSum'] = order.payment.chiPhiPhatSinh + order.payment.tienDuKien;
      tempOrder['tienCong'] = Helpers.FormatMoney(order.payment.chiPhiPhatSinh + order.payment.tienDuKien, true);

      // xử lý gom đơn theo bs số cũ => biển số mới
      // sắp xếp và tiến hành xử lý định dạng và gom dữ liệu lại kèm theo key là BS
      const tempDetail =
        order?.orderDetails?.map((item: any, index: number) => ({
          BsRL: item.oldRegistrationPlate + '=' + item.newRegistrationPlate,
          child: {
            ...item
          }
        })) || [];

      // bước tiếp theo là tiến hành gom các chi tiết có cùng bs cũ -> bs mới lại với nhau với child chứa các chi tiết bên trong đó
      // lưu ý là phải đúng với format bên form update
      const mergeList = new Map(tempDetail?.map(({ BsRL, child }) => [BsRL, { BsRL, child: [] }]));
      for (const { BsRL, child } of tempDetail) mergeList?.get(BsRL)?.child.push(...[child].flat());
      const tempList: any = [];

      for (let i = 0; i < [...mergeList.values()]?.length; i++) {
        let obj = {
          ...[...mergeList.values()][i]
        };
        if ([...mergeList.values()][i].child?.length != 0) {
          const objDetail: any = [];
          const objProduct: any = [];
          obj = {
            ...[...mergeList.values()][i].child[0]
          };

          for (let j = 0; j < [...mergeList.values()][i].child?.length; j++) {
            const obj = {
              id: [...mergeList.values()][i].child[j]['id'] || 0,
              cost: [...mergeList.values()][i].child[j]['cost'] || 0,
              maSanPham: [...mergeList.values()][i].child[j]['maSanPham'] || '',
              phone: [...mergeList.values()][i].child[j]['phone'] || '',
              serial: [...mergeList.values()][i].child[j]['serial'] || '',
              maSanPhamMoi: [...mergeList.values()][i].child[j]['maSanPhamMoi'] || '',
              phoneMoi: [...mergeList.values()][i].child[j]['phoneMoi'] || '',
              serialMoi: [...mergeList.values()][i].child[j]['serialMoi'] || '',
              note: [...mergeList.values()][i].child[j]['note'] || '',
              staffExecute: [...mergeList.values()][i].child[j]['staffExecute'] || '',

              old: true // cần có để check cho kth phân biệt nào cũ hay mới nhập
            };
            if ([...mergeList.values()][i].child[j]['maSanPham'] == '') {
              // mã cũ là rỗng nghĩa là sp bán thêm mới nằm trong list chi tiết
              objDetail.push(obj);
            } else {
              // mã cũ có thì là sản phẩm chính tháo lắp nên để trong product
              objProduct.push(obj);
            }
          }

          obj['details'] = objDetail || [];
          obj['products'] = objProduct || [];
          tempList.push(obj);
        }
      }
      tempOrder['replaces'] = tempList || [];

      const quantityDevice = tempOrder.replaces?.length;
      tempOrder['DeviceList'] = true;
      tempOrder['totalReplace'] = quantityDevice;
      tempOrder['DetailOrder'] = `${'Tháo.Lắp lại ' + (quantityDevice || 0) + ' bộ'}`;

      if (isReport) {
        // tiếp theo là xử lý chi tiết báo cáo nếu cần lấy data báo cáo
        tempOrder['thoiGianDieuDon'] =
          order?.statusDetails?.find(staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned')
            ?.updateTime === undefined
            ? ''
            : new Date(
                order?.statusDetails?.find(
                  staff => staff.staffBehavior == 'Assign' && staff.status == 'Assigned'
                )?.updateTime
              );
        tempOrder['itemsReport'] = [{ details: order.orderDetails }];
        tempOrder['StaffCancel'] = order.staffCancel || '';
        tempOrder['StaffProcesser'] = order.staffComplete || '';
        tempOrder['companyNameEx'] = COMPANY_NAMES.find(company => company.value == order.companyName)?.label || '';
      }
    }

    return tempOrder;
  },

  convertIdTypeOrderToNameAPI: (oderTypeId: number) => {
    switch (oderTypeId) {
      case 1:
      case 2:
      case 6:
      case 10: // đơn lắp giùm đly
        return 'GLD'; // đơn gửi, lắp hoặc thu đổi
      case 4:
      case 5:
        return 'SB'; // đơn sửa chữa bảo hành
      case 3:
        return 'TP'; // đơn thu phí
      case 7:
        return 'NC'; // đơn nâng cấp
      case 8:
        return 'TH'; // đơn tháo - lắp lại
      case 9:
        return 'DLL'; // đơn đại lý lắp dùm
      case 11:
        return 'TN'; // đơn thu nợ
      case 12:
        return 'THang'; // đơn trả hàng
      case 13:
        return 'ChenhLech'; // đơn chênh lệch
      case 14:
        return 'HoanTien'; // đơn hoàn tiền
      default:
        return '';
    }
  },

  makeDetailBase: (valueQuick: any, maSanPham: any, amount: any) => {
    const tempDetail: any[] = [];
    if (valueQuick?.length != 0) {
      // thêm theo bộ
      for (let i = 0; i < amount; i++) {
        for (let j = 0; j < valueQuick?.length; j++) {
          const aDetail = {
            id: crypto.randomUUID(),
            maSanPham: valueQuick[j] || undefined,
            serial: undefined,
            phone: undefined,
            maBo: maSanPham || ''
          };
          tempDetail.push(aDetail);
        }
      }
    } else {
      for (let i = 0; i < amount; i++) {
        const aDetail = {
          id: crypto.randomUUID(),
          maSanPham: maSanPham || undefined,
          phone: undefined,
          serial: undefined,
          maBo: ''
        };
        tempDetail.push(aDetail);
      }
    }

    return [...tempDetail];
  },

  handleCalSumByDetail: (data: any, preDevice: any) => {
    const listDevices: any = [];
    const listPrice: any = [];

    for (let i = 0; i < data?.length; i++) {
      for (let j = 0; j < data[i].details?.length; j++) {
        listDevices.push(data[i].details[j].maSanPham);
        listPrice.push(preDevice.find(preP => preP.maSanPham == data[i].details[j].maSanPham)?.cost || null);
      }
    }

    return {
      devices: listDevices,
      quantities: null,
      price: listPrice
    };
  }
};

export default UtilOrder;
